//Generated by scripts/20180711_GenerateTranslationKeys.sql
namespace OnlineDPR.Application.Shared.Translations
type TranslationKey =
| PortalName = 2375
| SignIn_Username_Placeholder = 2376
| SignIn_Username_Label = 2377
| SignIn_Password_Placeholder = 2378
| SignIn_Password_Label = 2379
| SignIn_Rememberme_Label = 2380
| SignIn_Submit_Label = 2381
| SignIn_Username_required = 2382
| SignIn_Password_required = 2383
| SignIn_PasswortDoesNotMatch = 2384
| DprNonOnfitUserInputMask_CalculatedField = 2385
| DprNonOnfitUserInputMask_MembersTotal = 2386
| DprNonOnfitUserInputMask_MembershipsActivePaying = 2387
| DprNonOnfitUserInputMask_MembershipsOnHold = 2388
| DprNonOnfitUserInputMask_OnHoldQuota = 2389
| DprNonOnfitUserInputMask_MembershipsNotPaying = 2390
| DprNonOnfitUserInputMask_MembershipsRenewal = 2391
| DprNonOnfitUserInputMask_NewMembershipsContractedTotal = 2392
| DprNonOnfitUserInputMask_NewMembershipsContractedFromFlyersOrClassicMail = 2393
| DprNonOnfitUserInputMask_NewMembershipsContractedFromRecommendations = 2394
| DprNonOnfitUserInputMask_NewMembershipsContractedFromAdsOrPressAnnouncement = 2395
| DprNonOnfitUserInputMask_NewMembershipsContractedFromExterior = 2396
| DprNonOnfitUserInputMask_NewMembershipsContractedFromStreetPromotion = 2397
| DprNonOnfitUserInputMask_NewMembershipsContractedFromLuckyBoxGame = 2398
| DprNonOnfitUserInputMask_NewMembershipsContractedFromDirectMailing = 2399
| DprNonOnfitUserInputMask_NewMembershipsContractedFromExternalOrInternalEvents = 2400
| DprNonOnfitUserInputMask_NewMembershipsContractedFromCooperations = 2401
| DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPasses = 2402
| DprNonOnfitUserInputMask_NewMembershipsContractedFromInternet = 2403
| DprNonOnfitUserInputMask_NewMembershipsContractedFromSMSTool = 2404
| DprNonOnfitUserInputMask_NewMembershipsContractedFromOrRadioTV = 2405
| DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherOutsideAds = 2406
| DprNonOnfitUserInputMask_NewMembershipsContractedFromFormerMembers = 2407
| DprNonOnfitUserInputMask_NewMembershipsContractedFromStudies = 2408
| DprNonOnfitUserInputMask_NewMembershipsContractedFromOutdoorTraining = 2409
| DprNonOnfitUserInputMask_NewMembershipsContractedFromHpm = 2410
| DprNonOnfitUserInputMask_NewMembershipsContractedFromFacebook = 2411
| DprNonOnfitUserInputMask_NewMembershipsContractedFromRestSources = 2412
| DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal1 = 2413
| DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromVisitors = 2414
| DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromVisitors = 2415
| DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromVisitors = 2416
| DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromVisitors = 2417
| DprNonOnfitUserInputMask_NewMembershipsContractedFromStudyTotal = 2418
| DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromStudy = 2419
| DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromStudy = 2420
| DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromStudy = 2421
| DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromStudy = 2422
| DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherSources = 2423
| DprNonOnfitUserInputMask_TotalSalesOpportunities = 2424
| DprNonOnfitUserInputMask_SalesQuotaTotal = 2425
| DprNonOnfitUserInputMask_SalesQuotaFromVisitors = 2426
| DprNonOnfitUserInputMask_Visitors = 2427
| DprNonOnfitUserInputMask_VisitorBookedProbeTraining = 2428
| DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal2 = 2429
| DprNonOnfitUserInputMask_BookingQuotaFromIncomingCalls = 2430
| DprNonOnfitUserInputMask_IncomingCallsTotal = 2431
| DprNonOnfitUserInputMask_BookingQuotaFromOutgoingCalls = 2432
| DprNonOnfitUserInputMask_CatchingQuotaFromOutgoingCalls = 2433
| DprNonOnfitUserInputMask_OutgoingCallsAttempted = 2434
| DprNonOnfitUserInputMask_OutgoingCallsSuccessful = 2435
| DprNonOnfitUserInputMask_VisitorsFromGuestPass = 2436
| DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPass = 2437
| DprNonOnfitUserInputMask_ClubTeamPromotionHours = 2438
| DprNonOnfitUserInputMask_FlyersSpread = 2439
| DprNonOnfitUserInputMask_AdsTakenOut = 2440
| DprNonOnfitUserInputMask_LocalCooperations = 2441
| DprNonOnfitUserInputMask_RecruitingEventsHosted = 2442
| DprNonOnfitUserInputMask_ContactsTotal = 2443
| DprNonOnfitUserInputMask_ContactsFromStreetPromotion = 2444
| DprNonOnfitUserInputMask_ContactsFromLuckyBoxGame = 2445
| DprNonOnfitUserInputMask_ContactsFromSMS = 2446
| DprNonOnfitUserInputMask_ContactsFromEmail = 2447
| DprNonOnfitUserInputMask_ContactsFromInternet = 2448
| DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEvents = 2449
| DprNonOnfitUserInputMask_ContactsFromOutdoorTraining = 2450
| DprNonOnfitUserInputMask_ContactsFromHpm = 2451
| DprNonOnfitUserInputMask_ContactsFromFacebook = 2452
| DprNonOnfitUserInputMask_ContactsFromOtherSources = 2453
| DprNonOnfitUserInputMask_GuestsTotal = 2454
| DprNonOnfitUserInputMask_GuestsFromFlyersOrClassicMail = 2455
| DprNonOnfitUserInputMask_GuestsFromRecommendations = 2456
| DprNonOnfitUserInputMask_ContactsFromRecommendations = 2457
| DprNonOnfitUserInputMask_GuestsFromAdsOrPressAnnouncement = 2458
| DprNonOnfitUserInputMask_GuestsFromExterior = 2459
| DprNonOnfitUserInputMask_GuestsFromStreetPromotion = 2460
| DprNonOnfitUserInputMask_GuestsFromLuckyBoxGame = 2461
| DprNonOnfitUserInputMask_GuestsFromDirectMailing = 2462
| DprNonOnfitUserInputMask_GuestsFromExternalOrInternalEvents = 2463
| DprNonOnfitUserInputMask_GuestsFromCooperations = 2464
| DprNonOnfitUserInputMask_GuestsFromGuestPasses = 2465
| DprNonOnfitUserInputMask_GuestsFromInternet = 2466
| DprNonOnfitUserInputMask_GuestsFromSMSTool = 2467
| DprNonOnfitUserInputMask_GuestsFromOrRadioTV = 2468
| DprNonOnfitUserInputMask_GuestsFromOtherOutsideAds = 2469
| DprNonOnfitUserInputMask_GuestsFromFormerMembers = 2470
| DprNonOnfitUserInputMask_GuestsFromStudies = 2471
| DprNonOnfitUserInputMask_GuestsFromOutdoorTraining = 2472
| DprNonOnfitUserInputMask_GuestsFromHpm = 2473
| DprNonOnfitUserInputMask_GuestsFromFacebook = 2474
| DprNonOnfitUserInputMask_GuestsFromOtherSources = 2475
| DprNonOnfitUserInputMask_CancellationQuota = 2476
| DprNonOnfitUserInputMask_IncomingCancellations = 2477
| DprNonOnfitUserInputMask_CancellationReason = 2478
| DprNonOnfitUserInputMask_CatchedCancellationCalls = 2479
| DprNonOnfitUserInputMask_CancellationsInterviewsInhouse = 2480
| DprNonOnfitUserInputMask_RevertedCancellations = 2481
| DprNonOnfitUserInputMask_ExpiringMemberships = 2482
| DprNonOnfitUserInputMask_AbsentQuota = 2483
| DprNonOnfitUserInputMask_MembersAbsentForTwoWeeks = 2484
| DprNonOnfitUserInputMask_MembersToday = 2485
| DprNonOnfitUserInputMask_TrainingDialogsDone = 2486
| DprNonOnfitUserInputMask_TrainingDialogsSuccsessful = 2487
| DprNonOnfitUserInputMask_CatchingQuotaForNewMembersList = 2488
| DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListAttempted = 2489
| DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListCatched = 2490
| DprNonOnfitUserInputMask_SuccessQuotaMotivationCalls = 2491
| DprNonOnfitUserInputMask_MotivationCallsAttempted = 2492
| DprNonOnfitUserInputMask_MotivationCallsSuccessful = 2493
| DprNonOnfitUserInputMask_MotiviationTrainingsBooked = 2494
| DprNonOnfitUserInputMask_MotiviationTrainingsDone = 2495
| DprNonOnfitUserInputMask_ThemeNightsTrainingNutritionDone = 2496
| DprNonOnfitUserInputMask_ThemeNightsNutritionInfoDone = 2497
| DprNonOnfitUserInputMask_ParticipantsInfoEvent = 2498
| DprNonOnfitUserInputMask_ParticipantsStudyOrAction = 2499
| DprNonOnfitUserInputMask_OutdoorTraningsDone = 2500
| DprNonOnfitUserInputMask_ParticipantsOutdoorTraning = 2501
| DprNonOnfitUserInputMask_HoursSpendForTeamTraining = 2502
| DprNonOnfitUserInputMask_SubmitButtonText = 2503
| DprNonOnfitUserInputMask_SubmitErrorTitle = 2504
| DprNonOnfitUserInputMask_SubmitErrorText = 2505
| DprNonOnfitUserInputMask_RecoveryBootsAppliedInternal = 2506
| DprNonOnfitUserInputMask_RecoveryBootsAppliedExternal = 2507
| DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldInternal = 2508
| DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldExternal = 2509
| DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalInternal = 2510
| DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalExternal = 2511
| DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledInternal = 2512
| DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledExternal = 2513
| DprNonOnfitUserInputMask_FusioneticsTrainings = 2514
| DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldInternal = 2515
| DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldExternal = 2516
| DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalInternal = 2517
| DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalExternal = 2518
| DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledInternal = 2519
| DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledExternal = 2520
| DprNonOnfitUserInputMask_RecoveryBootsTestSessionInternal = 2521
| DprNonOnfitUserInputMask_RecoveryBootsTestSessionExternal = 2522
| DprNonOnfitUserInputMask_ParticipantsFascialInfoEventInternal = 2523
| DprNonOnfitUserInputMask_ParticipantsFascialInfoEventExternal = 2524
| DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal1 = 2525
| DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromProbeTrainingOrConsultation = 2526
| DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromProbeTrainingOrConsultation = 2527
| DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromProbeTrainingOrConsultation = 2528
| DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromProbeTrainingOrConsultation = 2529
| DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsFromDateBook = 2530
| DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsDone = 2531
| DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal2 = 2532
| DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromIncomingCalls = 2533
| DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromOutgoingCalls = 2534
| DprNonOnfitUserInputMask_SalesQuotaFromProbeTrainingOrConsultation = 2535
| DprNonOnfitUserInputMask_ShowUpQuotaProbeTrainingOrConsultation = 2536
| DprNonOnfitUserInputMask_InquiriesTotal = 2537
| DprNonOnfitUserInputMask_ConversionRateQuota = 2538
| DprNonOnfitUserInputMask_PtgQuota = 2539
| DprNonOnfitUserInputMask_BeBacksFromDone = 2540
| DprNonOnfitUserInputMask_BeBacksFromCompleted = 2541
| DprNonOnfitUserInputMask_ErrorsInForm = 2542
| DprNonOnfitUserInputMask_GeneralErrorsModal_Title = 2543
| DprNonOnfitUserInputMask_GeneralErrorsModal_Text = 2544
| DprNonOnfitUserInputMask_Pricing20 = 2545
| DprNonOnfitUserInputMask_NewMembershipsContractedClassic = 2546
| DprNonOnfitUserInputMask_NewMembershipsContractedBasic = 2547
| DprNonOnfitUserInputMask_NewMembershipsContractedComfort = 2548
| DprNonOnfitUserInputMask_NewMembershipsContractedPremium = 2549
| DprNonOnfitUserInputMask_NewMembershipsContractedClassicPercent = 2550
| DprNonOnfitUserInputMask_NewMembershipsContractedBasicPercent = 2551
| DprNonOnfitUserInputMask_NewMembershipsContractedComfortPercent = 2552
| DprNonOnfitUserInputMask_NewMembershipsContractedPremiumPercent = 2553
| DprNonOnfitUserInputMask_UpsellingForPricing20Total = 2554
| DprNonOnfitUserInputMask_UpsellingForPricing20ClassicToPremium = 2555
| DprNonOnfitUserInputMask_UpsellingForPricing20BasicToComfort = 2556
| DprNonOnfitUserInputMask_UpsellingForPricing20BasicToPremium = 2557
| DprNonOnfitUserInputMask_UpsellingForPricing20ComfortToPremium = 2558
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20Classic = 2559
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20Basic = 2560
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20Comfort = 2561
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20Premium = 2562
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20ClassicPercent = 2563
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20BasicPercent = 2564
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20ComfortPercent = 2565
| DprNonOnfitUserInputMask_IncomingCancellationsPricing20PremiumPercent = 2566
| DprNonOnfitUserInputMask_MembersClassic = 2567
| DprNonOnfitUserInputMask_MembersBasic = 2568
| DprNonOnfitUserInputMask_MembersComfort = 2569
| DprNonOnfitUserInputMask_MembersPremium = 2570
| DprNonOnfitUserInputMask_MembersClassicPercent = 2571
| DprNonOnfitUserInputMask_MembersBasicPercent = 2572
| DprNonOnfitUserInputMask_MembersComfortPercent = 2573
| DprNonOnfitUserInputMask_MembersPremiumPercent = 2574
| DprNonOnfitUserInputMask_PelviPassesBookedTotal = 2575
| DprNonOnfitUserInputMask_Pelvi10PassBookedInternal = 2576
| DprNonOnfitUserInputMask_Pelvi20PassBookedInternal = 2577
| DprNonOnfitUserInputMask_Pelvi30PassBookedInternal = 2578
| DprNonOnfitUserInputMask_Pelvi40PassBookedInternal = 2579
| DprNonOnfitUserInputMask_PelviOtherPassBookedInternal = 2580
| DprNonOnfitUserInputMask_Pelvi10PassBookedExternal = 2581
| DprNonOnfitUserInputMask_Pelvi20PassBookedExternal = 2582
| DprNonOnfitUserInputMask_Pelvi30PassBookedExternal = 2583
| DprNonOnfitUserInputMask_Pelvi40PassBookedExternal = 2584
| DprNonOnfitUserInputMask_PelviOtherPassBookedExternal = 2585
| DprNonOnfitUserInputMask_PelviFollowUpBookedInternal = 2586
| DprNonOnfitUserInputMask_Pelvi10FollowUpBookedInternal = 2587
| DprNonOnfitUserInputMask_Pelvi20FollowUpBookedInternal = 2588
| DprNonOnfitUserInputMask_Pelvi30FollowUpBookedInternal = 2589
| DprNonOnfitUserInputMask_Pelvi40FollowUpBookedInternal = 2590
| DprNonOnfitUserInputMask_PelviOtherFollowUpBookedInternal = 2591
| DprNonOnfitUserInputMask_PelviFollowUpBookedExternal = 2592
| DprNonOnfitUserInputMask_Pelvi10FollowUpBookedExternal = 2593
| DprNonOnfitUserInputMask_Pelvi20FollowUpBookedExternal = 2594
| DprNonOnfitUserInputMask_Pelvi30FollowUpBookedExternal = 2595
| DprNonOnfitUserInputMask_Pelvi40FollowUpBookedExternal = 2596
| DprNonOnfitUserInputMask_PelviOtherFollowUpBookedExternal = 2597
| DprNonOnfitUserInputMask_PelviNewMembershipsContractedTotal = 2598
| DprNonOnfitUserInputMask_PelviNewYearlyMemberships = 2599
| DprNonOnfitUserInputMask_PelviNewMonthToMonthMemberships = 2600
| DprNonOnfitUserInputMask_PelviNewPrepaidMemberships = 2601
| DprNonOnfitUserInputMask_PelviNewOtherMemberships = 2602
| DprNonOnfitUserInputMask_PelviIncomingCancellationsTotal = 2603
| DprNonOnfitUserInputMask_PelviIncomingCancellationsYearlyMemberships = 2604
| DprNonOnfitUserInputMask_PelviIncomingCancellationsMonthToMonthMemberships = 2605
| DprNonOnfitUserInputMask_PelviIncomingCancellationsPrepaidMemberships = 2606
| DprNonOnfitUserInputMask_PelviIncomingCancellationsOtherMemberships = 2607
| DprNonOnfitUserInputMask_PelviAbosTotal = 2608
| DprNonOnfitUserInputMask_PelviAbosYearlyMemberships = 2609
| DprNonOnfitUserInputMask_PelviAbosMonthToMonthMemberships = 2610
| DprNonOnfitUserInputMask_PelviAbosPrepaidMemberships = 2611
| DprNonOnfitUserInputMask_PelviAbosOtherMemberships = 2612
| DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToComfort = 2613
| DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToPremium = 2614
| DprNonOnfitUserInputMask_PelviUpsellFromExternalToInternal = 2615
| DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookInternal = 2616
| DprNonOnfitUserInputMask_PelviProbeTrainingsDoneInternal = 2617
| DprNonOnfitUserInputMask_PelviSubscriptionsSoldInternal = 2618
| DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingInternal = 2619
| DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingInternal = 2620
| DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookExternal = 2621
| DprNonOnfitUserInputMask_PelviProbeTrainingsDoneExternal = 2622
| DprNonOnfitUserInputMask_PelviSubscriptionsSoldExternal = 2623
| DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingExternal = 2624
| DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingExternal = 2625
| DprNonOnfitUserInputMask_PelviOutgoingCallsAttempted = 2626
| DprNonOnfitUserInputMask_PelviOutgoingCallsSuccessful = 2627
| DprNonOnfitUserInputMask_PelviProbeTrainingsBookedFromOutgoingCalls = 2628
| DprNonOnfitUserInputMask_PelviCatchingQuotaForOutgoingCalls = 2629
| DprNonOnfitUserInputMask_PelviBookingQuotaFromOutgoingCalls = 2630
| DprNonOnfitUserInputMask_PelviBookedExternalTotal = 2631
| DprNonOnfitUserInputMask_PelviBookedExternalFromFlyersOrClassicMail = 2632
| DprNonOnfitUserInputMask_PelviBookedExternalFromRecommendations = 2633
| DprNonOnfitUserInputMask_PelviBookedExternalFromAdsOrPressAnnouncement = 2634
| DprNonOnfitUserInputMask_PelviBookedExternalFromExterior = 2635
| DprNonOnfitUserInputMask_PelviBookedExternalFromStreetPromotion = 2636
| DprNonOnfitUserInputMask_PelviBookedExternalFromLuckyBoxGame = 2637
| DprNonOnfitUserInputMask_PelviBookedExternalFromDirectMailing = 2638
| DprNonOnfitUserInputMask_PelviBookedExternalFromExternalOrInternalEvents = 2639
| DprNonOnfitUserInputMask_PelviBookedExternalFromCooperations = 2640
| DprNonOnfitUserInputMask_PelviBookedExternalFromGuestPasses = 2641
| DprNonOnfitUserInputMask_PelviBookedExternalFromInternet = 2642
| DprNonOnfitUserInputMask_PelviBookedExternalFromSMSTool = 2643
| DprNonOnfitUserInputMask_PelviBookedExternalFromOrRadioTV = 2644
| DprNonOnfitUserInputMask_PelviBookedExternalFromOtherOutsideAds = 2645
| DprNonOnfitUserInputMask_PelviBookedExternalFromFormerMembers = 2646
| DprNonOnfitUserInputMask_PelviBookedExternalFromStudies = 2647
| DprNonOnfitUserInputMask_PelviBookedExternalFromOutdoorTraining = 2648
| DprNonOnfitUserInputMask_PelviBookedExternalFromHpm = 2649
| DprNonOnfitUserInputMask_PelviBookedExternalFromFacebook = 2650
| DprNonOnfitUserInputMask_PelviBookedExternalFromRestSources = 2651
| DprNonOnfitUserInputMask_ContactsTotalPelvi = 2652
| DprNonOnfitUserInputMask_ContactsFromFlyersOrClassicMailPelvi = 2653
| DprNonOnfitUserInputMask_ContactsFromRecommendationsPelvi = 2654
| DprNonOnfitUserInputMask_ContactsFromAdsOrPressAnnouncementPelvi = 2655
| DprNonOnfitUserInputMask_ContactsFromExteriorPelvi = 2656
| DprNonOnfitUserInputMask_ContactsFromStreetPromotionPelvi = 2657
| DprNonOnfitUserInputMask_ContactsFromLuckyBoxGamePelvi = 2658
| DprNonOnfitUserInputMask_ContactsFromDirectMailingPelvi = 2659
| DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEventsPelvi = 2660
| DprNonOnfitUserInputMask_ContactsFromCooperationsPelvi = 2661
| DprNonOnfitUserInputMask_ContactsFromGuestPassesPelvi = 2662
| DprNonOnfitUserInputMask_ContactsFromInternetPelvi = 2663
| DprNonOnfitUserInputMask_ContactsFromSMSToolPelvi = 2664
| DprNonOnfitUserInputMask_ContactsFromOrRadioTVPelvi = 2665
| DprNonOnfitUserInputMask_ContactsFromOtherOutsideAdsPelvi = 2666
| DprNonOnfitUserInputMask_ContactsFromFormerMembersPelvi = 2667
| DprNonOnfitUserInputMask_ContactsFromStudiesPelvi = 2668
| DprNonOnfitUserInputMask_ContactsFromOutdoorTrainingPelvi = 2669
| DprNonOnfitUserInputMask_ContactsFromHpmPelvi = 2670
| DprNonOnfitUserInputMask_ContactsFromFacebookPelvi = 2671
| DprNonOnfitUserInputMask_ContactsFromRestSourcesPelvi = 2672
| DprCheckRule_OnlyZeros = 2673
| DprCheckRule_NoTotalMembers = 2674
| DprCheckRule_TooManyTotalMembers = 2675
| DprCheckRule_TooManyNewMembers = 2676
| DprCheckRule_SpreadFlyersInWrongField = 2677
| BwaInputMask_NettoSalesFromMembers = 2678
| BwaInputMask_NettoSalesFromMembers_Extend1 = 2679
| BwaInputMask_NettoIncomeFromPelviPower = 2680
| BwaInputMask_NettoIncomeFromPelviPower_Extend1 = 2681
| BwaInputMask_NettoIncomeFromBoots = 2682
| BwaInputMask_NettoIncomeFromBoots_Extend1 = 2683
| BwaInputMask_NettoIncomeFromFusionetics = 2684
| BwaInputMask_NettoIncomeFromFusionetics_Extend1 = 2685
| BwaInputMask_NettoIncomeFromKilosWeg = 2686
| BwaInputMask_NettoIncomeFromKilosWeg_Extend1 = 2687
| BwaInputMask_NettoOtherSales = 2688
| BwaInputMask_NettoOtherSales_Extend1 = 2689
| BwaInputMask_NettoSalesTotal = 2690
| BwaInputMask_NettoSalesTotal_Extend1 = 2691
| BwaInputMask_SalaryAndSocial = 2692
| BwaInputMask_SalaryAndSocial_Extend1 = 2693
| BwaInputMask_NettoRentAndAdditionalCosts = 2694
| BwaInputMask_NettoRentAndAdditionalCosts_Extend1 = 2695
| BwaInputMask_NettoLocalMarketingCosts = 2696
| BwaInputMask_NettoLocalMarketingCosts_Extend1 = 2697
| BwaInputMask_NettoOtherCosts = 2698
| BwaInputMask_NettoOtherCosts_Extend1 = 2699
| BwaInputMask_NettoCostsTotal = 2700
| BwaInputMask_NettoCostsTotal_Extend1 = 2701
| BwaInputMask_ResultEBITDA = 2702
| BwaInputMask_ResultEBITDA_Extend1 = 2703
| BwaInputMask_SubmitButtonText = 2704
| BwaInputMask_StatisticHeadline = 2705
| BwaInputMask_StatisticHeadline_Extend1 = 2706
| BwaInputMask_StatisticIncomeFromPelviPower = 2707
| BwaInputMask_StatisticIncomeFromPelviPower_Extend1 = 2708
| BwaInputMask_StatisticIncomeFromBoots = 2709
| BwaInputMask_StatisticIncomeFromBoots_Extend1 = 2710
| BwaInputMask_StatisticIncomeFromFusionetics = 2711
| BwaInputMask_StatisticIncomeFromFusionetics_Extend1 = 2712
| BwaInputMask_StatisticIncomeFromKilosWeg = 2713
| BwaInputMask_StatisticIncomeFromKilosWeg_Extend1 = 2714
| BwaInputMask_SubmitErrorTitle = 2715
| BwaInputMask_SubmitErrorText = 2716
| BwaInputMask_Validation_TooBig = 2717
| BwaInputMask_Validation_BelowZero = 2718
| FormValidation_NotAnInt = 2719
| FormValidation_NotADecimal = 2720
| FormValidation_MandatoryButEmpty = 2721
| FormValidation_NotADate = 2722
| FormValidation_DateToBig = 2723
| FormValidation_DateToSmall = 2724
| FormValidation_NotAClubWithDpr = 2725
| ReportHeadline_BlitzDpr = 2726
| ReportHeadline_existingMembers = 2727
| ReportHeadline_MembersRecruitingAndSalesprocess = 2728
| ReportHeadline_Marketing = 2729
| ReportHeadline_Loyalty = 2730
| ReportHeadline_Clubmanagement = 2731
| ReportHeadline_MrsSportyPlus = 2732
| ReportHeadline_MrsSportyPlus_RecoveryBoots = 2733
| ReportHeadline_MrsSportyPlus_Fusionetics = 2734
| ReportHeadline_MrsSportyPlus_PelviPower = 2735
| ReportHeadline_PelviPower_Plus_Abo = 2736
| ReportHeadline_MrsSportyPlus_PelviPower_Sales = 2737
| ReportHeadline_ExcelExportQuotaBlock = 2738
| ReportHeadline_Pricing20 = 2739
| ControlPanel_Title = 2740
| ControlPanel_SubTitle = 2741
| ControlPanel_Bwa_Title = 2742
| ControlPanel_Dpr_Title = 2743
| ControlPanel_Dpr_Report_Link_Text = 2744
| ControlPanel_Dpr_Legal_Title = 2745
| ControlPanel_Dpr_Legal_Text = 2746
| ControlPanel_Dpr_Legal_Link = 2747
| ControlPanel_Dpr_ClubSettings_Title = 2748
| ControlPanel_Dpr_ClubSettings_Text = 2749
| ControlPanel_Dpr_ClubSettings_Table_Club = 2750
| ControlPanel_Dpr_ClubSettings_Table_OptIn = 2751
| ControlPanel_Dpr_ClubSettings_Table_OptIn_NotAvailable = 2752
| ControlPanel_Dpr_ClubSettings_Table_OptIn_Blacklisted = 2753
| ControlPanel_Dpr_ClubSettings_Table_OptIn_OptOutMessage = 2754
| ControlPanel_Dpr_ClubSettings_Table_OptIn_OptInMessage = 2755
| ControlPanel_Dpr_EditDpr_Title = 2756
| ControlPanel_Dpr_EditDpr_EntryNotFoundError = 2757
| ControlPanel_Dpr_EditDpr_SubmitButtonText = 2758
| ControlPanel_Dpr_EditDpr_ClubLabelText = 2759
| ControlPanel_Notifications_BwaInput_Pending_Heading = 2760
| ControlPanel_Notifications_BwaInput_Pending_Text = 2761
| ControlPanel_Notifications_BwaInput_Pending_Linktext = 2762
| ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Heading = 2763
| ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Text = 2764
| ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Linktext = 2765
| ControlPanel_Notifications_DprInput_Pending_Heading = 2766
| ControlPanel_Notifications_DprInput_Pending_Text = 2767
| ControlPanel_Notifications_DprInput_Pending_Linktext = 2768
| ControlPanel_Notifications_DprInput_Skip_Linktext = 2769
| ControlPanel_Notifications_DprInput_Skip_Confirmation_Text = 2770
| ControlPanel_Invoices_Title = 2771
| ControlPanel_Invoices_Column_Invoice_Number_Title = 2772
| ControlPanel_Invoices_Column_Invoice_Date_Title = 2773
| ControlPanel_Invoices_Column_DueDate_Title = 2774
| ControlPanel_Invoices_Column_Club_Number_Title = 2775
| ControlPanel_Invoices_Column_Product_Title = 2776
| ControlPanel_Invoices_Column_Invoice_Amount_Title = 2777
| ControlPanel_Invoices_Column_Actions_Download = 2778
| ControlPanel_Invoices_Column_Actions_Show = 2779
| ControlPanel_Invoices_Column_Notes_Title = 2780
| ControlPanel_Invoices_No_Invoices_Message = 2781
| PasswordRecovery_PageTitle = 2782
| PasswordRecovery_ForgotPasswordLink = 2783
| PasswordRecovery_Info = 2784
| PasswordRecovery_EmailLabel = 2785
| PasswordRecovery_EmailPlaceholder = 2786
| PasswordRecovery_EmailMissing = 2787
| PasswordRecovery_EmailNotValid = 2788
| PasswordRecovery_ResetPasswordButton = 2789
| PasswordRecovery_BackToLogin = 2790
| PasswordRecovery_ForgotPasswordConfirmationPageTitle = 2791
| PasswordRecovery_ForgotPasswordConfirmation = 2792
| PasswordRecovery_EmailSubject = 2793
| PasswordRecovery_EmailText = 2794
| ResetPassword_PageTitle = 2795
| ResetPassword_Info = 2796
| ResetPassword_NewPasswordRequired = 2797
| ResetPassword_NewPasswordLabel = 2798
| ResetPassword_NewPasswordPlaceholder = 2799
| ResetPassword_ConfirmationLabel = 2800
| ResetPassword_ConfirmationDoesNotMatch = 2801
| ResetPassword_SetPassword = 2802
| ResetPassword_BackToHome = 2803
| ResetPassword_ConfirmationPageTitle = 2804
| ResetPassword_Confirmation = 2805
| ResetPassword_GeneralError = 2806
| RequestNewPassword_Title = 2807
| RequestNewPassword_Info = 2808
| RequestNewPassword_CurrentPasswordLabel = 2809
| RequestNewPassword_CurrentPasswordPlaceholder = 2810
| RequestNewPassword_CurrentPasswordMissing = 2811
| RequestNewPassword_PasswordDoesNotMatch = 2812
| RequestNewPassword_BackToHome = 2813
| ForceNewPassword_PageTitle = 2814
| ForceNewPassword_Info = 2815
| ForceNewPassword_Confirmation = 2816
| ForceNewPassword_Cancel = 2817
| Identity_PasswordRequiresDigit = 2818
| Identity_PasswordRequiresLower = 2819
| Identity_PasswordRequiresNonAlphanumeric = 2820
| Identity_PasswordRequiresUniqueChars = 2821
| Identity_PasswordRequiresUpper = 2822
| Identity_PasswordTooShort = 2823
| Identity_PasswordDoesntDiffer = 2824
| UserDropdown_ChangePassword = 2825
| UserDropdown_Logout = 2826
| Report_Intervall = 2827
| Report_Intervall_Month = 2828
| Report_Intervall_Quarter = 2829
| Report_Intervall_HalfYear = 2830
| Report_Intervall_Year = 2831
| Report_From = 2832
| Report_ExcelExport_Button = 2833
| Report_ExcelExport_LikeSelected = 2834
| Report_ExcelExport_CurrentMonth = 2835
| Report_ExcelExport_PreviousMonth = 2836
| Report_ExcelExport_CurrentYear = 2837
| Report_ExcelExport_PreviousYear = 2838
| Report_ExcelExport_PreviousTwoYears = 2839
| Report_ExcelExport_TotalPeriod = 2840
| Error_AccessDenied = 2841
| Error_AccessDenied_Text = 2842
| Error_AccessDenied_Logout = 2843
| Error_Back = 2844
| Error_GeneralError_Title = 2845
| Error_GeneralError_Text = 2846
| Error_500_Title = 2847
| Error_500_Text = 2848
| Error_404_Title = 2849
| Error_404_Text = 2850
| Error_503_Title = 2851
| Error_503_Text = 2852
| Dpr_Title = 2853
| Dpr_IncludeInReport = 2854
| Dpr_AggregatedSumValue = 2855
| Dpr_AggregatedAverageValue = 2856
| Dpr_Origin_Import = 2857
| Dpr_Origin_Sync = 2858
| Dpr_Origin_Manual = 2859
| DPRChart_DisplayDatalabels = 2860
| DprChart_Title = 2861
| DprChart_Type_Title = 2862
| DprChart_Type_Line = 2863
| DprChart_Type_Bar = 2864
| Imprint_Title = 2865
| Imprint_Back = 2866
| BlitzDprMail_DoNotReply = 2867
| BlitzDprMail_Club = 2868
| BlitzDprMail_CreationTimestamp = 2869
| BlitzDprMail_CoveredPeriod = 2870
| BlitzDprMail_Subject_FirstWord = 2871
| Modal_Close_Button_Text = 2872

[<RequireQualifiedAccess>]
module TranslationKeyStrings =
    let toEnumValue = Map [
                         ("PortalName", TranslationKey.PortalName);
                         ("SignIn_Username_Placeholder", TranslationKey.SignIn_Username_Placeholder);
                         ("SignIn_Username_Label", TranslationKey.SignIn_Username_Label);
                         ("SignIn_Password_Placeholder", TranslationKey.SignIn_Password_Placeholder);
                         ("SignIn_Password_Label", TranslationKey.SignIn_Password_Label);
                         ("SignIn_Rememberme_Label", TranslationKey.SignIn_Rememberme_Label);
                         ("SignIn_Submit_Label", TranslationKey.SignIn_Submit_Label);
                         ("SignIn_Username_required", TranslationKey.SignIn_Username_required);
                         ("SignIn_Password_required", TranslationKey.SignIn_Password_required);
                         ("SignIn_PasswortDoesNotMatch", TranslationKey.SignIn_PasswortDoesNotMatch);
                         ("DprNonOnfitUserInputMask_CalculatedField", TranslationKey.DprNonOnfitUserInputMask_CalculatedField);
                         ("DprNonOnfitUserInputMask_MembersTotal", TranslationKey.DprNonOnfitUserInputMask_MembersTotal);
                         ("DprNonOnfitUserInputMask_MembershipsActivePaying", TranslationKey.DprNonOnfitUserInputMask_MembershipsActivePaying);
                         ("DprNonOnfitUserInputMask_MembershipsOnHold", TranslationKey.DprNonOnfitUserInputMask_MembershipsOnHold);
                         ("DprNonOnfitUserInputMask_OnHoldQuota", TranslationKey.DprNonOnfitUserInputMask_OnHoldQuota);
                         ("DprNonOnfitUserInputMask_MembershipsNotPaying", TranslationKey.DprNonOnfitUserInputMask_MembershipsNotPaying);
                         ("DprNonOnfitUserInputMask_MembershipsRenewal", TranslationKey.DprNonOnfitUserInputMask_MembershipsRenewal);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedTotal", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedTotal);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromFlyersOrClassicMail", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromFlyersOrClassicMail);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromRecommendations", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromRecommendations);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromAdsOrPressAnnouncement", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromAdsOrPressAnnouncement);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromExterior", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromExterior);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromStreetPromotion", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromStreetPromotion);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromLuckyBoxGame", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromLuckyBoxGame);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromDirectMailing", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromDirectMailing);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromExternalOrInternalEvents", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromExternalOrInternalEvents);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromCooperations", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromCooperations);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPasses", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPasses);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromInternet", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromInternet);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromSMSTool", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromSMSTool);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromOrRadioTV", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromOrRadioTV);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherOutsideAds", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherOutsideAds);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromFormerMembers", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromFormerMembers);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromStudies", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromStudies);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromOutdoorTraining", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromOutdoorTraining);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromHpm", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromHpm);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromFacebook", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromFacebook);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromRestSources", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromRestSources);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal1", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal1);
                         ("DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromVisitors", TranslationKey.DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromVisitors);
                         ("DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromVisitors", TranslationKey.DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromVisitors);
                         ("DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromVisitors", TranslationKey.DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromVisitors);
                         ("DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromVisitors", TranslationKey.DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromVisitors);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromStudyTotal", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromStudyTotal);
                         ("DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromStudy", TranslationKey.DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromStudy);
                         ("DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromStudy", TranslationKey.DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromStudy);
                         ("DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromStudy", TranslationKey.DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromStudy);
                         ("DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromStudy", TranslationKey.DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromStudy);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherSources", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherSources);
                         ("DprNonOnfitUserInputMask_TotalSalesOpportunities", TranslationKey.DprNonOnfitUserInputMask_TotalSalesOpportunities);
                         ("DprNonOnfitUserInputMask_SalesQuotaTotal", TranslationKey.DprNonOnfitUserInputMask_SalesQuotaTotal);
                         ("DprNonOnfitUserInputMask_SalesQuotaFromVisitors", TranslationKey.DprNonOnfitUserInputMask_SalesQuotaFromVisitors);
                         ("DprNonOnfitUserInputMask_Visitors", TranslationKey.DprNonOnfitUserInputMask_Visitors);
                         ("DprNonOnfitUserInputMask_VisitorBookedProbeTraining", TranslationKey.DprNonOnfitUserInputMask_VisitorBookedProbeTraining);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal2", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal2);
                         ("DprNonOnfitUserInputMask_BookingQuotaFromIncomingCalls", TranslationKey.DprNonOnfitUserInputMask_BookingQuotaFromIncomingCalls);
                         ("DprNonOnfitUserInputMask_IncomingCallsTotal", TranslationKey.DprNonOnfitUserInputMask_IncomingCallsTotal);
                         ("DprNonOnfitUserInputMask_BookingQuotaFromOutgoingCalls", TranslationKey.DprNonOnfitUserInputMask_BookingQuotaFromOutgoingCalls);
                         ("DprNonOnfitUserInputMask_CatchingQuotaFromOutgoingCalls", TranslationKey.DprNonOnfitUserInputMask_CatchingQuotaFromOutgoingCalls);
                         ("DprNonOnfitUserInputMask_OutgoingCallsAttempted", TranslationKey.DprNonOnfitUserInputMask_OutgoingCallsAttempted);
                         ("DprNonOnfitUserInputMask_OutgoingCallsSuccessful", TranslationKey.DprNonOnfitUserInputMask_OutgoingCallsSuccessful);
                         ("DprNonOnfitUserInputMask_VisitorsFromGuestPass", TranslationKey.DprNonOnfitUserInputMask_VisitorsFromGuestPass);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPass", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPass);
                         ("DprNonOnfitUserInputMask_ClubTeamPromotionHours", TranslationKey.DprNonOnfitUserInputMask_ClubTeamPromotionHours);
                         ("DprNonOnfitUserInputMask_FlyersSpread", TranslationKey.DprNonOnfitUserInputMask_FlyersSpread);
                         ("DprNonOnfitUserInputMask_AdsTakenOut", TranslationKey.DprNonOnfitUserInputMask_AdsTakenOut);
                         ("DprNonOnfitUserInputMask_LocalCooperations", TranslationKey.DprNonOnfitUserInputMask_LocalCooperations);
                         ("DprNonOnfitUserInputMask_RecruitingEventsHosted", TranslationKey.DprNonOnfitUserInputMask_RecruitingEventsHosted);
                         ("DprNonOnfitUserInputMask_ContactsTotal", TranslationKey.DprNonOnfitUserInputMask_ContactsTotal);
                         ("DprNonOnfitUserInputMask_ContactsFromStreetPromotion", TranslationKey.DprNonOnfitUserInputMask_ContactsFromStreetPromotion);
                         ("DprNonOnfitUserInputMask_ContactsFromLuckyBoxGame", TranslationKey.DprNonOnfitUserInputMask_ContactsFromLuckyBoxGame);
                         ("DprNonOnfitUserInputMask_ContactsFromSMS", TranslationKey.DprNonOnfitUserInputMask_ContactsFromSMS);
                         ("DprNonOnfitUserInputMask_ContactsFromEmail", TranslationKey.DprNonOnfitUserInputMask_ContactsFromEmail);
                         ("DprNonOnfitUserInputMask_ContactsFromInternet", TranslationKey.DprNonOnfitUserInputMask_ContactsFromInternet);
                         ("DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEvents", TranslationKey.DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEvents);
                         ("DprNonOnfitUserInputMask_ContactsFromOutdoorTraining", TranslationKey.DprNonOnfitUserInputMask_ContactsFromOutdoorTraining);
                         ("DprNonOnfitUserInputMask_ContactsFromHpm", TranslationKey.DprNonOnfitUserInputMask_ContactsFromHpm);
                         ("DprNonOnfitUserInputMask_ContactsFromFacebook", TranslationKey.DprNonOnfitUserInputMask_ContactsFromFacebook);
                         ("DprNonOnfitUserInputMask_ContactsFromOtherSources", TranslationKey.DprNonOnfitUserInputMask_ContactsFromOtherSources);
                         ("DprNonOnfitUserInputMask_GuestsTotal", TranslationKey.DprNonOnfitUserInputMask_GuestsTotal);
                         ("DprNonOnfitUserInputMask_GuestsFromFlyersOrClassicMail", TranslationKey.DprNonOnfitUserInputMask_GuestsFromFlyersOrClassicMail);
                         ("DprNonOnfitUserInputMask_GuestsFromRecommendations", TranslationKey.DprNonOnfitUserInputMask_GuestsFromRecommendations);
                         ("DprNonOnfitUserInputMask_ContactsFromRecommendations", TranslationKey.DprNonOnfitUserInputMask_ContactsFromRecommendations);
                         ("DprNonOnfitUserInputMask_GuestsFromAdsOrPressAnnouncement", TranslationKey.DprNonOnfitUserInputMask_GuestsFromAdsOrPressAnnouncement);
                         ("DprNonOnfitUserInputMask_GuestsFromExterior", TranslationKey.DprNonOnfitUserInputMask_GuestsFromExterior);
                         ("DprNonOnfitUserInputMask_GuestsFromStreetPromotion", TranslationKey.DprNonOnfitUserInputMask_GuestsFromStreetPromotion);
                         ("DprNonOnfitUserInputMask_GuestsFromLuckyBoxGame", TranslationKey.DprNonOnfitUserInputMask_GuestsFromLuckyBoxGame);
                         ("DprNonOnfitUserInputMask_GuestsFromDirectMailing", TranslationKey.DprNonOnfitUserInputMask_GuestsFromDirectMailing);
                         ("DprNonOnfitUserInputMask_GuestsFromExternalOrInternalEvents", TranslationKey.DprNonOnfitUserInputMask_GuestsFromExternalOrInternalEvents);
                         ("DprNonOnfitUserInputMask_GuestsFromCooperations", TranslationKey.DprNonOnfitUserInputMask_GuestsFromCooperations);
                         ("DprNonOnfitUserInputMask_GuestsFromGuestPasses", TranslationKey.DprNonOnfitUserInputMask_GuestsFromGuestPasses);
                         ("DprNonOnfitUserInputMask_GuestsFromInternet", TranslationKey.DprNonOnfitUserInputMask_GuestsFromInternet);
                         ("DprNonOnfitUserInputMask_GuestsFromSMSTool", TranslationKey.DprNonOnfitUserInputMask_GuestsFromSMSTool);
                         ("DprNonOnfitUserInputMask_GuestsFromOrRadioTV", TranslationKey.DprNonOnfitUserInputMask_GuestsFromOrRadioTV);
                         ("DprNonOnfitUserInputMask_GuestsFromOtherOutsideAds", TranslationKey.DprNonOnfitUserInputMask_GuestsFromOtherOutsideAds);
                         ("DprNonOnfitUserInputMask_GuestsFromFormerMembers", TranslationKey.DprNonOnfitUserInputMask_GuestsFromFormerMembers);
                         ("DprNonOnfitUserInputMask_GuestsFromStudies", TranslationKey.DprNonOnfitUserInputMask_GuestsFromStudies);
                         ("DprNonOnfitUserInputMask_GuestsFromOutdoorTraining", TranslationKey.DprNonOnfitUserInputMask_GuestsFromOutdoorTraining);
                         ("DprNonOnfitUserInputMask_GuestsFromHpm", TranslationKey.DprNonOnfitUserInputMask_GuestsFromHpm);
                         ("DprNonOnfitUserInputMask_GuestsFromFacebook", TranslationKey.DprNonOnfitUserInputMask_GuestsFromFacebook);
                         ("DprNonOnfitUserInputMask_GuestsFromOtherSources", TranslationKey.DprNonOnfitUserInputMask_GuestsFromOtherSources);
                         ("DprNonOnfitUserInputMask_CancellationQuota", TranslationKey.DprNonOnfitUserInputMask_CancellationQuota);
                         ("DprNonOnfitUserInputMask_IncomingCancellations", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellations);
                         ("DprNonOnfitUserInputMask_CancellationReason", TranslationKey.DprNonOnfitUserInputMask_CancellationReason);
                         ("DprNonOnfitUserInputMask_CatchedCancellationCalls", TranslationKey.DprNonOnfitUserInputMask_CatchedCancellationCalls);
                         ("DprNonOnfitUserInputMask_CancellationsInterviewsInhouse", TranslationKey.DprNonOnfitUserInputMask_CancellationsInterviewsInhouse);
                         ("DprNonOnfitUserInputMask_RevertedCancellations", TranslationKey.DprNonOnfitUserInputMask_RevertedCancellations);
                         ("DprNonOnfitUserInputMask_ExpiringMemberships", TranslationKey.DprNonOnfitUserInputMask_ExpiringMemberships);
                         ("DprNonOnfitUserInputMask_AbsentQuota", TranslationKey.DprNonOnfitUserInputMask_AbsentQuota);
                         ("DprNonOnfitUserInputMask_MembersAbsentForTwoWeeks", TranslationKey.DprNonOnfitUserInputMask_MembersAbsentForTwoWeeks);
                         ("DprNonOnfitUserInputMask_MembersToday", TranslationKey.DprNonOnfitUserInputMask_MembersToday);
                         ("DprNonOnfitUserInputMask_TrainingDialogsDone", TranslationKey.DprNonOnfitUserInputMask_TrainingDialogsDone);
                         ("DprNonOnfitUserInputMask_TrainingDialogsSuccsessful", TranslationKey.DprNonOnfitUserInputMask_TrainingDialogsSuccsessful);
                         ("DprNonOnfitUserInputMask_CatchingQuotaForNewMembersList", TranslationKey.DprNonOnfitUserInputMask_CatchingQuotaForNewMembersList);
                         ("DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListAttempted", TranslationKey.DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListAttempted);
                         ("DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListCatched", TranslationKey.DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListCatched);
                         ("DprNonOnfitUserInputMask_SuccessQuotaMotivationCalls", TranslationKey.DprNonOnfitUserInputMask_SuccessQuotaMotivationCalls);
                         ("DprNonOnfitUserInputMask_MotivationCallsAttempted", TranslationKey.DprNonOnfitUserInputMask_MotivationCallsAttempted);
                         ("DprNonOnfitUserInputMask_MotivationCallsSuccessful", TranslationKey.DprNonOnfitUserInputMask_MotivationCallsSuccessful);
                         ("DprNonOnfitUserInputMask_MotiviationTrainingsBooked", TranslationKey.DprNonOnfitUserInputMask_MotiviationTrainingsBooked);
                         ("DprNonOnfitUserInputMask_MotiviationTrainingsDone", TranslationKey.DprNonOnfitUserInputMask_MotiviationTrainingsDone);
                         ("DprNonOnfitUserInputMask_ThemeNightsTrainingNutritionDone", TranslationKey.DprNonOnfitUserInputMask_ThemeNightsTrainingNutritionDone);
                         ("DprNonOnfitUserInputMask_ThemeNightsNutritionInfoDone", TranslationKey.DprNonOnfitUserInputMask_ThemeNightsNutritionInfoDone);
                         ("DprNonOnfitUserInputMask_ParticipantsInfoEvent", TranslationKey.DprNonOnfitUserInputMask_ParticipantsInfoEvent);
                         ("DprNonOnfitUserInputMask_ParticipantsStudyOrAction", TranslationKey.DprNonOnfitUserInputMask_ParticipantsStudyOrAction);
                         ("DprNonOnfitUserInputMask_OutdoorTraningsDone", TranslationKey.DprNonOnfitUserInputMask_OutdoorTraningsDone);
                         ("DprNonOnfitUserInputMask_ParticipantsOutdoorTraning", TranslationKey.DprNonOnfitUserInputMask_ParticipantsOutdoorTraning);
                         ("DprNonOnfitUserInputMask_HoursSpendForTeamTraining", TranslationKey.DprNonOnfitUserInputMask_HoursSpendForTeamTraining);
                         ("DprNonOnfitUserInputMask_SubmitButtonText", TranslationKey.DprNonOnfitUserInputMask_SubmitButtonText);
                         ("DprNonOnfitUserInputMask_SubmitErrorTitle", TranslationKey.DprNonOnfitUserInputMask_SubmitErrorTitle);
                         ("DprNonOnfitUserInputMask_SubmitErrorText", TranslationKey.DprNonOnfitUserInputMask_SubmitErrorText);
                         ("DprNonOnfitUserInputMask_RecoveryBootsAppliedInternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsAppliedInternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsAppliedExternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsAppliedExternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldInternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldInternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldExternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldExternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalInternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalInternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalExternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalExternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledInternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledInternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledExternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledExternal);
                         ("DprNonOnfitUserInputMask_FusioneticsTrainings", TranslationKey.DprNonOnfitUserInputMask_FusioneticsTrainings);
                         ("DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldInternal", TranslationKey.DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldInternal);
                         ("DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldExternal", TranslationKey.DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldExternal);
                         ("DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalInternal", TranslationKey.DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalInternal);
                         ("DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalExternal", TranslationKey.DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalExternal);
                         ("DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledInternal", TranslationKey.DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledInternal);
                         ("DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledExternal", TranslationKey.DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledExternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsTestSessionInternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsTestSessionInternal);
                         ("DprNonOnfitUserInputMask_RecoveryBootsTestSessionExternal", TranslationKey.DprNonOnfitUserInputMask_RecoveryBootsTestSessionExternal);
                         ("DprNonOnfitUserInputMask_ParticipantsFascialInfoEventInternal", TranslationKey.DprNonOnfitUserInputMask_ParticipantsFascialInfoEventInternal);
                         ("DprNonOnfitUserInputMask_ParticipantsFascialInfoEventExternal", TranslationKey.DprNonOnfitUserInputMask_ParticipantsFascialInfoEventExternal);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal1", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal1);
                         ("DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromProbeTrainingOrConsultation", TranslationKey.DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromProbeTrainingOrConsultation);
                         ("DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromProbeTrainingOrConsultation", TranslationKey.DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromProbeTrainingOrConsultation);
                         ("DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromProbeTrainingOrConsultation", TranslationKey.DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromProbeTrainingOrConsultation);
                         ("DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromProbeTrainingOrConsultation", TranslationKey.DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromProbeTrainingOrConsultation);
                         ("DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsFromDateBook", TranslationKey.DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsFromDateBook);
                         ("DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsDone", TranslationKey.DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsDone);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal2", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal2);
                         ("DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromIncomingCalls", TranslationKey.DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromIncomingCalls);
                         ("DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromOutgoingCalls", TranslationKey.DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromOutgoingCalls);
                         ("DprNonOnfitUserInputMask_SalesQuotaFromProbeTrainingOrConsultation", TranslationKey.DprNonOnfitUserInputMask_SalesQuotaFromProbeTrainingOrConsultation);
                         ("DprNonOnfitUserInputMask_ShowUpQuotaProbeTrainingOrConsultation", TranslationKey.DprNonOnfitUserInputMask_ShowUpQuotaProbeTrainingOrConsultation);
                         ("DprNonOnfitUserInputMask_InquiriesTotal", TranslationKey.DprNonOnfitUserInputMask_InquiriesTotal);
                         ("DprNonOnfitUserInputMask_ConversionRateQuota", TranslationKey.DprNonOnfitUserInputMask_ConversionRateQuota);
                         ("DprNonOnfitUserInputMask_PtgQuota", TranslationKey.DprNonOnfitUserInputMask_PtgQuota);
                         ("DprNonOnfitUserInputMask_BeBacksFromDone", TranslationKey.DprNonOnfitUserInputMask_BeBacksFromDone);
                         ("DprNonOnfitUserInputMask_BeBacksFromCompleted", TranslationKey.DprNonOnfitUserInputMask_BeBacksFromCompleted);
                         ("DprNonOnfitUserInputMask_ErrorsInForm", TranslationKey.DprNonOnfitUserInputMask_ErrorsInForm);
                         ("DprNonOnfitUserInputMask_GeneralErrorsModal_Title", TranslationKey.DprNonOnfitUserInputMask_GeneralErrorsModal_Title);
                         ("DprNonOnfitUserInputMask_GeneralErrorsModal_Text", TranslationKey.DprNonOnfitUserInputMask_GeneralErrorsModal_Text);
                         ("DprNonOnfitUserInputMask_Pricing20", TranslationKey.DprNonOnfitUserInputMask_Pricing20);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedClassic", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedClassic);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedBasic", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedBasic);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedComfort", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedComfort);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedPremium", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedPremium);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedClassicPercent", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedClassicPercent);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedBasicPercent", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedBasicPercent);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedComfortPercent", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedComfortPercent);
                         ("DprNonOnfitUserInputMask_NewMembershipsContractedPremiumPercent", TranslationKey.DprNonOnfitUserInputMask_NewMembershipsContractedPremiumPercent);
                         ("DprNonOnfitUserInputMask_UpsellingForPricing20Total", TranslationKey.DprNonOnfitUserInputMask_UpsellingForPricing20Total);
                         ("DprNonOnfitUserInputMask_UpsellingForPricing20ClassicToPremium", TranslationKey.DprNonOnfitUserInputMask_UpsellingForPricing20ClassicToPremium);
                         ("DprNonOnfitUserInputMask_UpsellingForPricing20BasicToComfort", TranslationKey.DprNonOnfitUserInputMask_UpsellingForPricing20BasicToComfort);
                         ("DprNonOnfitUserInputMask_UpsellingForPricing20BasicToPremium", TranslationKey.DprNonOnfitUserInputMask_UpsellingForPricing20BasicToPremium);
                         ("DprNonOnfitUserInputMask_UpsellingForPricing20ComfortToPremium", TranslationKey.DprNonOnfitUserInputMask_UpsellingForPricing20ComfortToPremium);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20Classic", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20Classic);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20Basic", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20Basic);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20Comfort", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20Comfort);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20Premium", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20Premium);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20ClassicPercent", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20ClassicPercent);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20BasicPercent", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20BasicPercent);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20ComfortPercent", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20ComfortPercent);
                         ("DprNonOnfitUserInputMask_IncomingCancellationsPricing20PremiumPercent", TranslationKey.DprNonOnfitUserInputMask_IncomingCancellationsPricing20PremiumPercent);
                         ("DprNonOnfitUserInputMask_MembersClassic", TranslationKey.DprNonOnfitUserInputMask_MembersClassic);
                         ("DprNonOnfitUserInputMask_MembersBasic", TranslationKey.DprNonOnfitUserInputMask_MembersBasic);
                         ("DprNonOnfitUserInputMask_MembersComfort", TranslationKey.DprNonOnfitUserInputMask_MembersComfort);
                         ("DprNonOnfitUserInputMask_MembersPremium", TranslationKey.DprNonOnfitUserInputMask_MembersPremium);
                         ("DprNonOnfitUserInputMask_MembersClassicPercent", TranslationKey.DprNonOnfitUserInputMask_MembersClassicPercent);
                         ("DprNonOnfitUserInputMask_MembersBasicPercent", TranslationKey.DprNonOnfitUserInputMask_MembersBasicPercent);
                         ("DprNonOnfitUserInputMask_MembersComfortPercent", TranslationKey.DprNonOnfitUserInputMask_MembersComfortPercent);
                         ("DprNonOnfitUserInputMask_MembersPremiumPercent", TranslationKey.DprNonOnfitUserInputMask_MembersPremiumPercent);
                         ("DprNonOnfitUserInputMask_PelviPassesBookedTotal", TranslationKey.DprNonOnfitUserInputMask_PelviPassesBookedTotal);
                         ("DprNonOnfitUserInputMask_Pelvi10PassBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi10PassBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi20PassBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi20PassBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi30PassBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi30PassBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi40PassBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi40PassBookedInternal);
                         ("DprNonOnfitUserInputMask_PelviOtherPassBookedInternal", TranslationKey.DprNonOnfitUserInputMask_PelviOtherPassBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi10PassBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi10PassBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi20PassBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi20PassBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi30PassBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi30PassBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi40PassBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi40PassBookedExternal);
                         ("DprNonOnfitUserInputMask_PelviOtherPassBookedExternal", TranslationKey.DprNonOnfitUserInputMask_PelviOtherPassBookedExternal);
                         ("DprNonOnfitUserInputMask_PelviFollowUpBookedInternal", TranslationKey.DprNonOnfitUserInputMask_PelviFollowUpBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi10FollowUpBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi10FollowUpBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi20FollowUpBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi20FollowUpBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi30FollowUpBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi30FollowUpBookedInternal);
                         ("DprNonOnfitUserInputMask_Pelvi40FollowUpBookedInternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi40FollowUpBookedInternal);
                         ("DprNonOnfitUserInputMask_PelviOtherFollowUpBookedInternal", TranslationKey.DprNonOnfitUserInputMask_PelviOtherFollowUpBookedInternal);
                         ("DprNonOnfitUserInputMask_PelviFollowUpBookedExternal", TranslationKey.DprNonOnfitUserInputMask_PelviFollowUpBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi10FollowUpBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi10FollowUpBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi20FollowUpBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi20FollowUpBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi30FollowUpBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi30FollowUpBookedExternal);
                         ("DprNonOnfitUserInputMask_Pelvi40FollowUpBookedExternal", TranslationKey.DprNonOnfitUserInputMask_Pelvi40FollowUpBookedExternal);
                         ("DprNonOnfitUserInputMask_PelviOtherFollowUpBookedExternal", TranslationKey.DprNonOnfitUserInputMask_PelviOtherFollowUpBookedExternal);
                         ("DprNonOnfitUserInputMask_PelviNewMembershipsContractedTotal", TranslationKey.DprNonOnfitUserInputMask_PelviNewMembershipsContractedTotal);
                         ("DprNonOnfitUserInputMask_PelviNewYearlyMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviNewYearlyMemberships);
                         ("DprNonOnfitUserInputMask_PelviNewMonthToMonthMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviNewMonthToMonthMemberships);
                         ("DprNonOnfitUserInputMask_PelviNewPrepaidMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviNewPrepaidMemberships);
                         ("DprNonOnfitUserInputMask_PelviNewOtherMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviNewOtherMemberships);
                         ("DprNonOnfitUserInputMask_PelviIncomingCancellationsTotal", TranslationKey.DprNonOnfitUserInputMask_PelviIncomingCancellationsTotal);
                         ("DprNonOnfitUserInputMask_PelviIncomingCancellationsYearlyMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviIncomingCancellationsYearlyMemberships);
                         ("DprNonOnfitUserInputMask_PelviIncomingCancellationsMonthToMonthMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviIncomingCancellationsMonthToMonthMemberships);
                         ("DprNonOnfitUserInputMask_PelviIncomingCancellationsPrepaidMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviIncomingCancellationsPrepaidMemberships);
                         ("DprNonOnfitUserInputMask_PelviIncomingCancellationsOtherMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviIncomingCancellationsOtherMemberships);
                         ("DprNonOnfitUserInputMask_PelviAbosTotal", TranslationKey.DprNonOnfitUserInputMask_PelviAbosTotal);
                         ("DprNonOnfitUserInputMask_PelviAbosYearlyMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviAbosYearlyMemberships);
                         ("DprNonOnfitUserInputMask_PelviAbosMonthToMonthMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviAbosMonthToMonthMemberships);
                         ("DprNonOnfitUserInputMask_PelviAbosPrepaidMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviAbosPrepaidMemberships);
                         ("DprNonOnfitUserInputMask_PelviAbosOtherMemberships", TranslationKey.DprNonOnfitUserInputMask_PelviAbosOtherMemberships);
                         ("DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToComfort", TranslationKey.DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToComfort);
                         ("DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToPremium", TranslationKey.DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToPremium);
                         ("DprNonOnfitUserInputMask_PelviUpsellFromExternalToInternal", TranslationKey.DprNonOnfitUserInputMask_PelviUpsellFromExternalToInternal);
                         ("DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookInternal", TranslationKey.DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookInternal);
                         ("DprNonOnfitUserInputMask_PelviProbeTrainingsDoneInternal", TranslationKey.DprNonOnfitUserInputMask_PelviProbeTrainingsDoneInternal);
                         ("DprNonOnfitUserInputMask_PelviSubscriptionsSoldInternal", TranslationKey.DprNonOnfitUserInputMask_PelviSubscriptionsSoldInternal);
                         ("DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingInternal", TranslationKey.DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingInternal);
                         ("DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingInternal", TranslationKey.DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingInternal);
                         ("DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookExternal", TranslationKey.DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookExternal);
                         ("DprNonOnfitUserInputMask_PelviProbeTrainingsDoneExternal", TranslationKey.DprNonOnfitUserInputMask_PelviProbeTrainingsDoneExternal);
                         ("DprNonOnfitUserInputMask_PelviSubscriptionsSoldExternal", TranslationKey.DprNonOnfitUserInputMask_PelviSubscriptionsSoldExternal);
                         ("DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingExternal", TranslationKey.DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingExternal);
                         ("DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingExternal", TranslationKey.DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingExternal);
                         ("DprNonOnfitUserInputMask_PelviOutgoingCallsAttempted", TranslationKey.DprNonOnfitUserInputMask_PelviOutgoingCallsAttempted);
                         ("DprNonOnfitUserInputMask_PelviOutgoingCallsSuccessful", TranslationKey.DprNonOnfitUserInputMask_PelviOutgoingCallsSuccessful);
                         ("DprNonOnfitUserInputMask_PelviProbeTrainingsBookedFromOutgoingCalls", TranslationKey.DprNonOnfitUserInputMask_PelviProbeTrainingsBookedFromOutgoingCalls);
                         ("DprNonOnfitUserInputMask_PelviCatchingQuotaForOutgoingCalls", TranslationKey.DprNonOnfitUserInputMask_PelviCatchingQuotaForOutgoingCalls);
                         ("DprNonOnfitUserInputMask_PelviBookingQuotaFromOutgoingCalls", TranslationKey.DprNonOnfitUserInputMask_PelviBookingQuotaFromOutgoingCalls);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalTotal", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalTotal);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromFlyersOrClassicMail", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromFlyersOrClassicMail);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromRecommendations", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromRecommendations);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromAdsOrPressAnnouncement", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromAdsOrPressAnnouncement);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromExterior", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromExterior);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromStreetPromotion", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromStreetPromotion);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromLuckyBoxGame", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromLuckyBoxGame);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromDirectMailing", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromDirectMailing);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromExternalOrInternalEvents", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromExternalOrInternalEvents);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromCooperations", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromCooperations);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromGuestPasses", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromGuestPasses);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromInternet", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromInternet);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromSMSTool", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromSMSTool);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromOrRadioTV", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromOrRadioTV);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromOtherOutsideAds", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromOtherOutsideAds);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromFormerMembers", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromFormerMembers);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromStudies", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromStudies);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromOutdoorTraining", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromOutdoorTraining);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromHpm", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromHpm);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromFacebook", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromFacebook);
                         ("DprNonOnfitUserInputMask_PelviBookedExternalFromRestSources", TranslationKey.DprNonOnfitUserInputMask_PelviBookedExternalFromRestSources);
                         ("DprNonOnfitUserInputMask_ContactsTotalPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsTotalPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromFlyersOrClassicMailPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromFlyersOrClassicMailPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromRecommendationsPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromRecommendationsPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromAdsOrPressAnnouncementPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromAdsOrPressAnnouncementPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromExteriorPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromExteriorPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromStreetPromotionPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromStreetPromotionPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromLuckyBoxGamePelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromLuckyBoxGamePelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromDirectMailingPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromDirectMailingPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEventsPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEventsPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromCooperationsPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromCooperationsPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromGuestPassesPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromGuestPassesPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromInternetPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromInternetPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromSMSToolPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromSMSToolPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromOrRadioTVPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromOrRadioTVPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromOtherOutsideAdsPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromOtherOutsideAdsPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromFormerMembersPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromFormerMembersPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromStudiesPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromStudiesPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromOutdoorTrainingPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromOutdoorTrainingPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromHpmPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromHpmPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromFacebookPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromFacebookPelvi);
                         ("DprNonOnfitUserInputMask_ContactsFromRestSourcesPelvi", TranslationKey.DprNonOnfitUserInputMask_ContactsFromRestSourcesPelvi);
                         ("DprCheckRule_OnlyZeros", TranslationKey.DprCheckRule_OnlyZeros);
                         ("DprCheckRule_NoTotalMembers", TranslationKey.DprCheckRule_NoTotalMembers);
                         ("DprCheckRule_TooManyTotalMembers", TranslationKey.DprCheckRule_TooManyTotalMembers);
                         ("DprCheckRule_TooManyNewMembers", TranslationKey.DprCheckRule_TooManyNewMembers);
                         ("DprCheckRule_SpreadFlyersInWrongField", TranslationKey.DprCheckRule_SpreadFlyersInWrongField);
                         ("BwaInputMask_NettoSalesFromMembers", TranslationKey.BwaInputMask_NettoSalesFromMembers);
                         ("BwaInputMask_NettoSalesFromMembers_Extend1", TranslationKey.BwaInputMask_NettoSalesFromMembers_Extend1);
                         ("BwaInputMask_NettoIncomeFromPelviPower", TranslationKey.BwaInputMask_NettoIncomeFromPelviPower);
                         ("BwaInputMask_NettoIncomeFromPelviPower_Extend1", TranslationKey.BwaInputMask_NettoIncomeFromPelviPower_Extend1);
                         ("BwaInputMask_NettoIncomeFromBoots", TranslationKey.BwaInputMask_NettoIncomeFromBoots);
                         ("BwaInputMask_NettoIncomeFromBoots_Extend1", TranslationKey.BwaInputMask_NettoIncomeFromBoots_Extend1);
                         ("BwaInputMask_NettoIncomeFromFusionetics", TranslationKey.BwaInputMask_NettoIncomeFromFusionetics);
                         ("BwaInputMask_NettoIncomeFromFusionetics_Extend1", TranslationKey.BwaInputMask_NettoIncomeFromFusionetics_Extend1);
                         ("BwaInputMask_NettoIncomeFromKilosWeg", TranslationKey.BwaInputMask_NettoIncomeFromKilosWeg);
                         ("BwaInputMask_NettoIncomeFromKilosWeg_Extend1", TranslationKey.BwaInputMask_NettoIncomeFromKilosWeg_Extend1);
                         ("BwaInputMask_NettoOtherSales", TranslationKey.BwaInputMask_NettoOtherSales);
                         ("BwaInputMask_NettoOtherSales_Extend1", TranslationKey.BwaInputMask_NettoOtherSales_Extend1);
                         ("BwaInputMask_NettoSalesTotal", TranslationKey.BwaInputMask_NettoSalesTotal);
                         ("BwaInputMask_NettoSalesTotal_Extend1", TranslationKey.BwaInputMask_NettoSalesTotal_Extend1);
                         ("BwaInputMask_SalaryAndSocial", TranslationKey.BwaInputMask_SalaryAndSocial);
                         ("BwaInputMask_SalaryAndSocial_Extend1", TranslationKey.BwaInputMask_SalaryAndSocial_Extend1);
                         ("BwaInputMask_NettoRentAndAdditionalCosts", TranslationKey.BwaInputMask_NettoRentAndAdditionalCosts);
                         ("BwaInputMask_NettoRentAndAdditionalCosts_Extend1", TranslationKey.BwaInputMask_NettoRentAndAdditionalCosts_Extend1);
                         ("BwaInputMask_NettoLocalMarketingCosts", TranslationKey.BwaInputMask_NettoLocalMarketingCosts);
                         ("BwaInputMask_NettoLocalMarketingCosts_Extend1", TranslationKey.BwaInputMask_NettoLocalMarketingCosts_Extend1);
                         ("BwaInputMask_NettoOtherCosts", TranslationKey.BwaInputMask_NettoOtherCosts);
                         ("BwaInputMask_NettoOtherCosts_Extend1", TranslationKey.BwaInputMask_NettoOtherCosts_Extend1);
                         ("BwaInputMask_NettoCostsTotal", TranslationKey.BwaInputMask_NettoCostsTotal);
                         ("BwaInputMask_NettoCostsTotal_Extend1", TranslationKey.BwaInputMask_NettoCostsTotal_Extend1);
                         ("BwaInputMask_ResultEBITDA", TranslationKey.BwaInputMask_ResultEBITDA);
                         ("BwaInputMask_ResultEBITDA_Extend1", TranslationKey.BwaInputMask_ResultEBITDA_Extend1);
                         ("BwaInputMask_SubmitButtonText", TranslationKey.BwaInputMask_SubmitButtonText);
                         ("BwaInputMask_StatisticHeadline", TranslationKey.BwaInputMask_StatisticHeadline);
                         ("BwaInputMask_StatisticHeadline_Extend1", TranslationKey.BwaInputMask_StatisticHeadline_Extend1);
                         ("BwaInputMask_StatisticIncomeFromPelviPower", TranslationKey.BwaInputMask_StatisticIncomeFromPelviPower);
                         ("BwaInputMask_StatisticIncomeFromPelviPower_Extend1", TranslationKey.BwaInputMask_StatisticIncomeFromPelviPower_Extend1);
                         ("BwaInputMask_StatisticIncomeFromBoots", TranslationKey.BwaInputMask_StatisticIncomeFromBoots);
                         ("BwaInputMask_StatisticIncomeFromBoots_Extend1", TranslationKey.BwaInputMask_StatisticIncomeFromBoots_Extend1);
                         ("BwaInputMask_StatisticIncomeFromFusionetics", TranslationKey.BwaInputMask_StatisticIncomeFromFusionetics);
                         ("BwaInputMask_StatisticIncomeFromFusionetics_Extend1", TranslationKey.BwaInputMask_StatisticIncomeFromFusionetics_Extend1);
                         ("BwaInputMask_StatisticIncomeFromKilosWeg", TranslationKey.BwaInputMask_StatisticIncomeFromKilosWeg);
                         ("BwaInputMask_StatisticIncomeFromKilosWeg_Extend1", TranslationKey.BwaInputMask_StatisticIncomeFromKilosWeg_Extend1);
                         ("BwaInputMask_SubmitErrorTitle", TranslationKey.BwaInputMask_SubmitErrorTitle);
                         ("BwaInputMask_SubmitErrorText", TranslationKey.BwaInputMask_SubmitErrorText);
                         ("BwaInputMask_Validation_TooBig", TranslationKey.BwaInputMask_Validation_TooBig);
                         ("BwaInputMask_Validation_BelowZero", TranslationKey.BwaInputMask_Validation_BelowZero);
                         ("FormValidation_NotAnInt", TranslationKey.FormValidation_NotAnInt);
                         ("FormValidation_NotADecimal", TranslationKey.FormValidation_NotADecimal);
                         ("FormValidation_MandatoryButEmpty", TranslationKey.FormValidation_MandatoryButEmpty);
                         ("FormValidation_NotADate", TranslationKey.FormValidation_NotADate);
                         ("FormValidation_DateToBig", TranslationKey.FormValidation_DateToBig);
                         ("FormValidation_DateToSmall", TranslationKey.FormValidation_DateToSmall);
                         ("FormValidation_NotAClubWithDpr", TranslationKey.FormValidation_NotAClubWithDpr);
                         ("ReportHeadline_BlitzDpr", TranslationKey.ReportHeadline_BlitzDpr);
                         ("ReportHeadline_existingMembers", TranslationKey.ReportHeadline_existingMembers);
                         ("ReportHeadline_MembersRecruitingAndSalesprocess", TranslationKey.ReportHeadline_MembersRecruitingAndSalesprocess);
                         ("ReportHeadline_Marketing", TranslationKey.ReportHeadline_Marketing);
                         ("ReportHeadline_Loyalty", TranslationKey.ReportHeadline_Loyalty);
                         ("ReportHeadline_Clubmanagement", TranslationKey.ReportHeadline_Clubmanagement);
                         ("ReportHeadline_MrsSportyPlus", TranslationKey.ReportHeadline_MrsSportyPlus);
                         ("ReportHeadline_MrsSportyPlus_RecoveryBoots", TranslationKey.ReportHeadline_MrsSportyPlus_RecoveryBoots);
                         ("ReportHeadline_MrsSportyPlus_Fusionetics", TranslationKey.ReportHeadline_MrsSportyPlus_Fusionetics);
                         ("ReportHeadline_MrsSportyPlus_PelviPower", TranslationKey.ReportHeadline_MrsSportyPlus_PelviPower);
                         ("ReportHeadline_PelviPower_Plus_Abo", TranslationKey.ReportHeadline_PelviPower_Plus_Abo);
                         ("ReportHeadline_MrsSportyPlus_PelviPower_Sales", TranslationKey.ReportHeadline_MrsSportyPlus_PelviPower_Sales);
                         ("ReportHeadline_ExcelExportQuotaBlock", TranslationKey.ReportHeadline_ExcelExportQuotaBlock);
                         ("ReportHeadline_Pricing20", TranslationKey.ReportHeadline_Pricing20);
                         ("ControlPanel_Title", TranslationKey.ControlPanel_Title);
                         ("ControlPanel_SubTitle", TranslationKey.ControlPanel_SubTitle);
                         ("ControlPanel_Bwa_Title", TranslationKey.ControlPanel_Bwa_Title);
                         ("ControlPanel_Dpr_Title", TranslationKey.ControlPanel_Dpr_Title);
                         ("ControlPanel_Dpr_Report_Link_Text", TranslationKey.ControlPanel_Dpr_Report_Link_Text);
                         ("ControlPanel_Dpr_Legal_Title", TranslationKey.ControlPanel_Dpr_Legal_Title);
                         ("ControlPanel_Dpr_Legal_Text", TranslationKey.ControlPanel_Dpr_Legal_Text);
                         ("ControlPanel_Dpr_Legal_Link", TranslationKey.ControlPanel_Dpr_Legal_Link);
                         ("ControlPanel_Dpr_ClubSettings_Title", TranslationKey.ControlPanel_Dpr_ClubSettings_Title);
                         ("ControlPanel_Dpr_ClubSettings_Text", TranslationKey.ControlPanel_Dpr_ClubSettings_Text);
                         ("ControlPanel_Dpr_ClubSettings_Table_Club", TranslationKey.ControlPanel_Dpr_ClubSettings_Table_Club);
                         ("ControlPanel_Dpr_ClubSettings_Table_OptIn", TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn);
                         ("ControlPanel_Dpr_ClubSettings_Table_OptIn_NotAvailable", TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_NotAvailable);
                         ("ControlPanel_Dpr_ClubSettings_Table_OptIn_Blacklisted", TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_Blacklisted);
                         ("ControlPanel_Dpr_ClubSettings_Table_OptIn_OptOutMessage", TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_OptOutMessage);
                         ("ControlPanel_Dpr_ClubSettings_Table_OptIn_OptInMessage", TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_OptInMessage);
                         ("ControlPanel_Dpr_EditDpr_Title", TranslationKey.ControlPanel_Dpr_EditDpr_Title);
                         ("ControlPanel_Dpr_EditDpr_EntryNotFoundError", TranslationKey.ControlPanel_Dpr_EditDpr_EntryNotFoundError);
                         ("ControlPanel_Dpr_EditDpr_SubmitButtonText", TranslationKey.ControlPanel_Dpr_EditDpr_SubmitButtonText);
                         ("ControlPanel_Dpr_EditDpr_ClubLabelText", TranslationKey.ControlPanel_Dpr_EditDpr_ClubLabelText);
                         ("ControlPanel_Notifications_BwaInput_Pending_Heading", TranslationKey.ControlPanel_Notifications_BwaInput_Pending_Heading);
                         ("ControlPanel_Notifications_BwaInput_Pending_Text", TranslationKey.ControlPanel_Notifications_BwaInput_Pending_Text);
                         ("ControlPanel_Notifications_BwaInput_Pending_Linktext", TranslationKey.ControlPanel_Notifications_BwaInput_Pending_Linktext);
                         ("ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Heading", TranslationKey.ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Heading);
                         ("ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Text", TranslationKey.ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Text);
                         ("ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Linktext", TranslationKey.ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Linktext);
                         ("ControlPanel_Notifications_DprInput_Pending_Heading", TranslationKey.ControlPanel_Notifications_DprInput_Pending_Heading);
                         ("ControlPanel_Notifications_DprInput_Pending_Text", TranslationKey.ControlPanel_Notifications_DprInput_Pending_Text);
                         ("ControlPanel_Notifications_DprInput_Pending_Linktext", TranslationKey.ControlPanel_Notifications_DprInput_Pending_Linktext);
                         ("ControlPanel_Notifications_DprInput_Skip_Linktext", TranslationKey.ControlPanel_Notifications_DprInput_Skip_Linktext);
                         ("ControlPanel_Notifications_DprInput_Skip_Confirmation_Text", TranslationKey.ControlPanel_Notifications_DprInput_Skip_Confirmation_Text);
                         ("ControlPanel_Invoices_Title", TranslationKey.ControlPanel_Invoices_Title);
                         ("ControlPanel_Invoices_Column_Invoice_Number_Title", TranslationKey.ControlPanel_Invoices_Column_Invoice_Number_Title);
                         ("ControlPanel_Invoices_Column_Invoice_Date_Title", TranslationKey.ControlPanel_Invoices_Column_Invoice_Date_Title);
                         ("ControlPanel_Invoices_Column_DueDate_Title", TranslationKey.ControlPanel_Invoices_Column_DueDate_Title);
                         ("ControlPanel_Invoices_Column_Club_Number_Title", TranslationKey.ControlPanel_Invoices_Column_Club_Number_Title);
                         ("ControlPanel_Invoices_Column_Product_Title", TranslationKey.ControlPanel_Invoices_Column_Product_Title);
                         ("ControlPanel_Invoices_Column_Invoice_Amount_Title", TranslationKey.ControlPanel_Invoices_Column_Invoice_Amount_Title);
                         ("ControlPanel_Invoices_Column_Actions_Download", TranslationKey.ControlPanel_Invoices_Column_Actions_Download);
                         ("ControlPanel_Invoices_Column_Actions_Show", TranslationKey.ControlPanel_Invoices_Column_Actions_Show);
                         ("ControlPanel_Invoices_Column_Notes_Title", TranslationKey.ControlPanel_Invoices_Column_Notes_Title);
                         ("ControlPanel_Invoices_No_Invoices_Message", TranslationKey.ControlPanel_Invoices_No_Invoices_Message);
                         ("PasswordRecovery_PageTitle", TranslationKey.PasswordRecovery_PageTitle);
                         ("PasswordRecovery_ForgotPasswordLink", TranslationKey.PasswordRecovery_ForgotPasswordLink);
                         ("PasswordRecovery_Info", TranslationKey.PasswordRecovery_Info);
                         ("PasswordRecovery_EmailLabel", TranslationKey.PasswordRecovery_EmailLabel);
                         ("PasswordRecovery_EmailPlaceholder", TranslationKey.PasswordRecovery_EmailPlaceholder);
                         ("PasswordRecovery_EmailMissing", TranslationKey.PasswordRecovery_EmailMissing);
                         ("PasswordRecovery_EmailNotValid", TranslationKey.PasswordRecovery_EmailNotValid);
                         ("PasswordRecovery_ResetPasswordButton", TranslationKey.PasswordRecovery_ResetPasswordButton);
                         ("PasswordRecovery_BackToLogin", TranslationKey.PasswordRecovery_BackToLogin);
                         ("PasswordRecovery_ForgotPasswordConfirmationPageTitle", TranslationKey.PasswordRecovery_ForgotPasswordConfirmationPageTitle);
                         ("PasswordRecovery_ForgotPasswordConfirmation", TranslationKey.PasswordRecovery_ForgotPasswordConfirmation);
                         ("PasswordRecovery_EmailSubject", TranslationKey.PasswordRecovery_EmailSubject);
                         ("PasswordRecovery_EmailText", TranslationKey.PasswordRecovery_EmailText);
                         ("ResetPassword_PageTitle", TranslationKey.ResetPassword_PageTitle);
                         ("ResetPassword_Info", TranslationKey.ResetPassword_Info);
                         ("ResetPassword_NewPasswordRequired", TranslationKey.ResetPassword_NewPasswordRequired);
                         ("ResetPassword_NewPasswordLabel", TranslationKey.ResetPassword_NewPasswordLabel);
                         ("ResetPassword_NewPasswordPlaceholder", TranslationKey.ResetPassword_NewPasswordPlaceholder);
                         ("ResetPassword_ConfirmationLabel", TranslationKey.ResetPassword_ConfirmationLabel);
                         ("ResetPassword_ConfirmationDoesNotMatch", TranslationKey.ResetPassword_ConfirmationDoesNotMatch);
                         ("ResetPassword_SetPassword", TranslationKey.ResetPassword_SetPassword);
                         ("ResetPassword_BackToHome", TranslationKey.ResetPassword_BackToHome);
                         ("ResetPassword_ConfirmationPageTitle", TranslationKey.ResetPassword_ConfirmationPageTitle);
                         ("ResetPassword_Confirmation", TranslationKey.ResetPassword_Confirmation);
                         ("ResetPassword_GeneralError", TranslationKey.ResetPassword_GeneralError);
                         ("RequestNewPassword_Title", TranslationKey.RequestNewPassword_Title);
                         ("RequestNewPassword_Info", TranslationKey.RequestNewPassword_Info);
                         ("RequestNewPassword_CurrentPasswordLabel", TranslationKey.RequestNewPassword_CurrentPasswordLabel);
                         ("RequestNewPassword_CurrentPasswordPlaceholder", TranslationKey.RequestNewPassword_CurrentPasswordPlaceholder);
                         ("RequestNewPassword_CurrentPasswordMissing", TranslationKey.RequestNewPassword_CurrentPasswordMissing);
                         ("RequestNewPassword_PasswordDoesNotMatch", TranslationKey.RequestNewPassword_PasswordDoesNotMatch);
                         ("RequestNewPassword_BackToHome", TranslationKey.RequestNewPassword_BackToHome);
                         ("ForceNewPassword_PageTitle", TranslationKey.ForceNewPassword_PageTitle);
                         ("ForceNewPassword_Info", TranslationKey.ForceNewPassword_Info);
                         ("ForceNewPassword_Confirmation", TranslationKey.ForceNewPassword_Confirmation);
                         ("ForceNewPassword_Cancel", TranslationKey.ForceNewPassword_Cancel);
                         ("Identity_PasswordRequiresDigit", TranslationKey.Identity_PasswordRequiresDigit);
                         ("Identity_PasswordRequiresLower", TranslationKey.Identity_PasswordRequiresLower);
                         ("Identity_PasswordRequiresNonAlphanumeric", TranslationKey.Identity_PasswordRequiresNonAlphanumeric);
                         ("Identity_PasswordRequiresUniqueChars", TranslationKey.Identity_PasswordRequiresUniqueChars);
                         ("Identity_PasswordRequiresUpper", TranslationKey.Identity_PasswordRequiresUpper);
                         ("Identity_PasswordTooShort", TranslationKey.Identity_PasswordTooShort);
                         ("Identity_PasswordDoesntDiffer", TranslationKey.Identity_PasswordDoesntDiffer);
                         ("UserDropdown_ChangePassword", TranslationKey.UserDropdown_ChangePassword);
                         ("UserDropdown_Logout", TranslationKey.UserDropdown_Logout);
                         ("Report_Intervall", TranslationKey.Report_Intervall);
                         ("Report_Intervall_Month", TranslationKey.Report_Intervall_Month);
                         ("Report_Intervall_Quarter", TranslationKey.Report_Intervall_Quarter);
                         ("Report_Intervall_HalfYear", TranslationKey.Report_Intervall_HalfYear);
                         ("Report_Intervall_Year", TranslationKey.Report_Intervall_Year);
                         ("Report_From", TranslationKey.Report_From);
                         ("Report_ExcelExport_Button", TranslationKey.Report_ExcelExport_Button);
                         ("Report_ExcelExport_LikeSelected", TranslationKey.Report_ExcelExport_LikeSelected);
                         ("Report_ExcelExport_CurrentMonth", TranslationKey.Report_ExcelExport_CurrentMonth);
                         ("Report_ExcelExport_PreviousMonth", TranslationKey.Report_ExcelExport_PreviousMonth);
                         ("Report_ExcelExport_CurrentYear", TranslationKey.Report_ExcelExport_CurrentYear);
                         ("Report_ExcelExport_PreviousYear", TranslationKey.Report_ExcelExport_PreviousYear);
                         ("Report_ExcelExport_PreviousTwoYears", TranslationKey.Report_ExcelExport_PreviousTwoYears);
                         ("Report_ExcelExport_TotalPeriod", TranslationKey.Report_ExcelExport_TotalPeriod);
                         ("Error_AccessDenied", TranslationKey.Error_AccessDenied);
                         ("Error_AccessDenied_Text", TranslationKey.Error_AccessDenied_Text);
                         ("Error_AccessDenied_Logout", TranslationKey.Error_AccessDenied_Logout);
                         ("Error_Back", TranslationKey.Error_Back);
                         ("Error_GeneralError_Title", TranslationKey.Error_GeneralError_Title);
                         ("Error_GeneralError_Text", TranslationKey.Error_GeneralError_Text);
                         ("Error_500_Title", TranslationKey.Error_500_Title);
                         ("Error_500_Text", TranslationKey.Error_500_Text);
                         ("Error_404_Title", TranslationKey.Error_404_Title);
                         ("Error_404_Text", TranslationKey.Error_404_Text);
                         ("Error_503_Title", TranslationKey.Error_503_Title);
                         ("Error_503_Text", TranslationKey.Error_503_Text);
                         ("Dpr_Title", TranslationKey.Dpr_Title);
                         ("Dpr_IncludeInReport", TranslationKey.Dpr_IncludeInReport);
                         ("Dpr_AggregatedSumValue", TranslationKey.Dpr_AggregatedSumValue);
                         ("Dpr_AggregatedAverageValue", TranslationKey.Dpr_AggregatedAverageValue);
                         ("Dpr_Origin_Import", TranslationKey.Dpr_Origin_Import);
                         ("Dpr_Origin_Sync", TranslationKey.Dpr_Origin_Sync);
                         ("Dpr_Origin_Manual", TranslationKey.Dpr_Origin_Manual);
                         ("DPRChart_DisplayDatalabels", TranslationKey.DPRChart_DisplayDatalabels);
                         ("DprChart_Title", TranslationKey.DprChart_Title);
                         ("DprChart_Type_Title", TranslationKey.DprChart_Type_Title);
                         ("DprChart_Type_Line", TranslationKey.DprChart_Type_Line);
                         ("DprChart_Type_Bar", TranslationKey.DprChart_Type_Bar);
                         ("Imprint_Title", TranslationKey.Imprint_Title);
                         ("Imprint_Back", TranslationKey.Imprint_Back);
                         ("BlitzDprMail_DoNotReply", TranslationKey.BlitzDprMail_DoNotReply);
                         ("BlitzDprMail_Club", TranslationKey.BlitzDprMail_Club);
                         ("BlitzDprMail_CreationTimestamp", TranslationKey.BlitzDprMail_CreationTimestamp);
                         ("BlitzDprMail_CoveredPeriod", TranslationKey.BlitzDprMail_CoveredPeriod);
                         ("BlitzDprMail_Subject_FirstWord", TranslationKey.BlitzDprMail_Subject_FirstWord);
                         ("Modal_Close_Button_Text", TranslationKey.Modal_Close_Button_Text);
                          ]

    [<Literal>]
    let PortalName = "PortalName"
    [<Literal>]
    let SignIn_Username_Placeholder = "SignIn_Username_Placeholder"
    [<Literal>]
    let SignIn_Username_Label = "SignIn_Username_Label"
    [<Literal>]
    let SignIn_Password_Placeholder = "SignIn_Password_Placeholder"
    [<Literal>]
    let SignIn_Password_Label = "SignIn_Password_Label"
    [<Literal>]
    let SignIn_Rememberme_Label = "SignIn_Rememberme_Label"
    [<Literal>]
    let SignIn_Submit_Label = "SignIn_Submit_Label"
    [<Literal>]
    let SignIn_Username_required = "SignIn_Username_required"
    [<Literal>]
    let SignIn_Password_required = "SignIn_Password_required"
    [<Literal>]
    let SignIn_PasswortDoesNotMatch = "SignIn_PasswortDoesNotMatch"
    [<Literal>]
    let DprNonOnfitUserInputMask_CalculatedField = "DprNonOnfitUserInputMask_CalculatedField"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersTotal = "DprNonOnfitUserInputMask_MembersTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembershipsActivePaying = "DprNonOnfitUserInputMask_MembershipsActivePaying"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembershipsOnHold = "DprNonOnfitUserInputMask_MembershipsOnHold"
    [<Literal>]
    let DprNonOnfitUserInputMask_OnHoldQuota = "DprNonOnfitUserInputMask_OnHoldQuota"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembershipsNotPaying = "DprNonOnfitUserInputMask_MembershipsNotPaying"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembershipsRenewal = "DprNonOnfitUserInputMask_MembershipsRenewal"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedTotal = "DprNonOnfitUserInputMask_NewMembershipsContractedTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromFlyersOrClassicMail = "DprNonOnfitUserInputMask_NewMembershipsContractedFromFlyersOrClassicMail"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromRecommendations = "DprNonOnfitUserInputMask_NewMembershipsContractedFromRecommendations"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromAdsOrPressAnnouncement = "DprNonOnfitUserInputMask_NewMembershipsContractedFromAdsOrPressAnnouncement"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromExterior = "DprNonOnfitUserInputMask_NewMembershipsContractedFromExterior"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromStreetPromotion = "DprNonOnfitUserInputMask_NewMembershipsContractedFromStreetPromotion"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromLuckyBoxGame = "DprNonOnfitUserInputMask_NewMembershipsContractedFromLuckyBoxGame"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromDirectMailing = "DprNonOnfitUserInputMask_NewMembershipsContractedFromDirectMailing"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromExternalOrInternalEvents = "DprNonOnfitUserInputMask_NewMembershipsContractedFromExternalOrInternalEvents"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromCooperations = "DprNonOnfitUserInputMask_NewMembershipsContractedFromCooperations"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPasses = "DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPasses"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromInternet = "DprNonOnfitUserInputMask_NewMembershipsContractedFromInternet"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromSMSTool = "DprNonOnfitUserInputMask_NewMembershipsContractedFromSMSTool"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromOrRadioTV = "DprNonOnfitUserInputMask_NewMembershipsContractedFromOrRadioTV"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherOutsideAds = "DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherOutsideAds"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromFormerMembers = "DprNonOnfitUserInputMask_NewMembershipsContractedFromFormerMembers"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromStudies = "DprNonOnfitUserInputMask_NewMembershipsContractedFromStudies"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromOutdoorTraining = "DprNonOnfitUserInputMask_NewMembershipsContractedFromOutdoorTraining"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromHpm = "DprNonOnfitUserInputMask_NewMembershipsContractedFromHpm"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromFacebook = "DprNonOnfitUserInputMask_NewMembershipsContractedFromFacebook"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromRestSources = "DprNonOnfitUserInputMask_NewMembershipsContractedFromRestSources"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal1 = "DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal1"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromVisitors = "DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromVisitors"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromVisitors = "DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromVisitors"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromVisitors = "DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromVisitors"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromVisitors = "DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromVisitors"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromStudyTotal = "DprNonOnfitUserInputMask_NewMembershipsContractedFromStudyTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromStudy = "DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromStudy"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromStudy = "DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromStudy"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromStudy = "DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromStudy"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromStudy = "DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromStudy"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherSources = "DprNonOnfitUserInputMask_NewMembershipsContractedFromOtherSources"
    [<Literal>]
    let DprNonOnfitUserInputMask_TotalSalesOpportunities = "DprNonOnfitUserInputMask_TotalSalesOpportunities"
    [<Literal>]
    let DprNonOnfitUserInputMask_SalesQuotaTotal = "DprNonOnfitUserInputMask_SalesQuotaTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_SalesQuotaFromVisitors = "DprNonOnfitUserInputMask_SalesQuotaFromVisitors"
    [<Literal>]
    let DprNonOnfitUserInputMask_Visitors = "DprNonOnfitUserInputMask_Visitors"
    [<Literal>]
    let DprNonOnfitUserInputMask_VisitorBookedProbeTraining = "DprNonOnfitUserInputMask_VisitorBookedProbeTraining"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal2 = "DprNonOnfitUserInputMask_NewMembershipsContractedFromVisitorsTotal2"
    [<Literal>]
    let DprNonOnfitUserInputMask_BookingQuotaFromIncomingCalls = "DprNonOnfitUserInputMask_BookingQuotaFromIncomingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCallsTotal = "DprNonOnfitUserInputMask_IncomingCallsTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_BookingQuotaFromOutgoingCalls = "DprNonOnfitUserInputMask_BookingQuotaFromOutgoingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_CatchingQuotaFromOutgoingCalls = "DprNonOnfitUserInputMask_CatchingQuotaFromOutgoingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_OutgoingCallsAttempted = "DprNonOnfitUserInputMask_OutgoingCallsAttempted"
    [<Literal>]
    let DprNonOnfitUserInputMask_OutgoingCallsSuccessful = "DprNonOnfitUserInputMask_OutgoingCallsSuccessful"
    [<Literal>]
    let DprNonOnfitUserInputMask_VisitorsFromGuestPass = "DprNonOnfitUserInputMask_VisitorsFromGuestPass"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPass = "DprNonOnfitUserInputMask_NewMembershipsContractedFromGuestPass"
    [<Literal>]
    let DprNonOnfitUserInputMask_ClubTeamPromotionHours = "DprNonOnfitUserInputMask_ClubTeamPromotionHours"
    [<Literal>]
    let DprNonOnfitUserInputMask_FlyersSpread = "DprNonOnfitUserInputMask_FlyersSpread"
    [<Literal>]
    let DprNonOnfitUserInputMask_AdsTakenOut = "DprNonOnfitUserInputMask_AdsTakenOut"
    [<Literal>]
    let DprNonOnfitUserInputMask_LocalCooperations = "DprNonOnfitUserInputMask_LocalCooperations"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecruitingEventsHosted = "DprNonOnfitUserInputMask_RecruitingEventsHosted"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsTotal = "DprNonOnfitUserInputMask_ContactsTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromStreetPromotion = "DprNonOnfitUserInputMask_ContactsFromStreetPromotion"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromLuckyBoxGame = "DprNonOnfitUserInputMask_ContactsFromLuckyBoxGame"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromSMS = "DprNonOnfitUserInputMask_ContactsFromSMS"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromEmail = "DprNonOnfitUserInputMask_ContactsFromEmail"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromInternet = "DprNonOnfitUserInputMask_ContactsFromInternet"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEvents = "DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEvents"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromOutdoorTraining = "DprNonOnfitUserInputMask_ContactsFromOutdoorTraining"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromHpm = "DprNonOnfitUserInputMask_ContactsFromHpm"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromFacebook = "DprNonOnfitUserInputMask_ContactsFromFacebook"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromOtherSources = "DprNonOnfitUserInputMask_ContactsFromOtherSources"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsTotal = "DprNonOnfitUserInputMask_GuestsTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromFlyersOrClassicMail = "DprNonOnfitUserInputMask_GuestsFromFlyersOrClassicMail"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromRecommendations = "DprNonOnfitUserInputMask_GuestsFromRecommendations"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromRecommendations = "DprNonOnfitUserInputMask_ContactsFromRecommendations"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromAdsOrPressAnnouncement = "DprNonOnfitUserInputMask_GuestsFromAdsOrPressAnnouncement"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromExterior = "DprNonOnfitUserInputMask_GuestsFromExterior"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromStreetPromotion = "DprNonOnfitUserInputMask_GuestsFromStreetPromotion"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromLuckyBoxGame = "DprNonOnfitUserInputMask_GuestsFromLuckyBoxGame"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromDirectMailing = "DprNonOnfitUserInputMask_GuestsFromDirectMailing"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromExternalOrInternalEvents = "DprNonOnfitUserInputMask_GuestsFromExternalOrInternalEvents"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromCooperations = "DprNonOnfitUserInputMask_GuestsFromCooperations"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromGuestPasses = "DprNonOnfitUserInputMask_GuestsFromGuestPasses"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromInternet = "DprNonOnfitUserInputMask_GuestsFromInternet"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromSMSTool = "DprNonOnfitUserInputMask_GuestsFromSMSTool"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromOrRadioTV = "DprNonOnfitUserInputMask_GuestsFromOrRadioTV"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromOtherOutsideAds = "DprNonOnfitUserInputMask_GuestsFromOtherOutsideAds"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromFormerMembers = "DprNonOnfitUserInputMask_GuestsFromFormerMembers"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromStudies = "DprNonOnfitUserInputMask_GuestsFromStudies"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromOutdoorTraining = "DprNonOnfitUserInputMask_GuestsFromOutdoorTraining"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromHpm = "DprNonOnfitUserInputMask_GuestsFromHpm"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromFacebook = "DprNonOnfitUserInputMask_GuestsFromFacebook"
    [<Literal>]
    let DprNonOnfitUserInputMask_GuestsFromOtherSources = "DprNonOnfitUserInputMask_GuestsFromOtherSources"
    [<Literal>]
    let DprNonOnfitUserInputMask_CancellationQuota = "DprNonOnfitUserInputMask_CancellationQuota"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellations = "DprNonOnfitUserInputMask_IncomingCancellations"
    [<Literal>]
    let DprNonOnfitUserInputMask_CancellationReason = "DprNonOnfitUserInputMask_CancellationReason"
    [<Literal>]
    let DprNonOnfitUserInputMask_CatchedCancellationCalls = "DprNonOnfitUserInputMask_CatchedCancellationCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_CancellationsInterviewsInhouse = "DprNonOnfitUserInputMask_CancellationsInterviewsInhouse"
    [<Literal>]
    let DprNonOnfitUserInputMask_RevertedCancellations = "DprNonOnfitUserInputMask_RevertedCancellations"
    [<Literal>]
    let DprNonOnfitUserInputMask_ExpiringMemberships = "DprNonOnfitUserInputMask_ExpiringMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_AbsentQuota = "DprNonOnfitUserInputMask_AbsentQuota"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersAbsentForTwoWeeks = "DprNonOnfitUserInputMask_MembersAbsentForTwoWeeks"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersToday = "DprNonOnfitUserInputMask_MembersToday"
    [<Literal>]
    let DprNonOnfitUserInputMask_TrainingDialogsDone = "DprNonOnfitUserInputMask_TrainingDialogsDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_TrainingDialogsSuccsessful = "DprNonOnfitUserInputMask_TrainingDialogsSuccsessful"
    [<Literal>]
    let DprNonOnfitUserInputMask_CatchingQuotaForNewMembersList = "DprNonOnfitUserInputMask_CatchingQuotaForNewMembersList"
    [<Literal>]
    let DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListAttempted = "DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListAttempted"
    [<Literal>]
    let DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListCatched = "DprNonOnfitUserInputMask_OutgoingCallsFromNewMembersListCatched"
    [<Literal>]
    let DprNonOnfitUserInputMask_SuccessQuotaMotivationCalls = "DprNonOnfitUserInputMask_SuccessQuotaMotivationCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_MotivationCallsAttempted = "DprNonOnfitUserInputMask_MotivationCallsAttempted"
    [<Literal>]
    let DprNonOnfitUserInputMask_MotivationCallsSuccessful = "DprNonOnfitUserInputMask_MotivationCallsSuccessful"
    [<Literal>]
    let DprNonOnfitUserInputMask_MotiviationTrainingsBooked = "DprNonOnfitUserInputMask_MotiviationTrainingsBooked"
    [<Literal>]
    let DprNonOnfitUserInputMask_MotiviationTrainingsDone = "DprNonOnfitUserInputMask_MotiviationTrainingsDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_ThemeNightsTrainingNutritionDone = "DprNonOnfitUserInputMask_ThemeNightsTrainingNutritionDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_ThemeNightsNutritionInfoDone = "DprNonOnfitUserInputMask_ThemeNightsNutritionInfoDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_ParticipantsInfoEvent = "DprNonOnfitUserInputMask_ParticipantsInfoEvent"
    [<Literal>]
    let DprNonOnfitUserInputMask_ParticipantsStudyOrAction = "DprNonOnfitUserInputMask_ParticipantsStudyOrAction"
    [<Literal>]
    let DprNonOnfitUserInputMask_OutdoorTraningsDone = "DprNonOnfitUserInputMask_OutdoorTraningsDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_ParticipantsOutdoorTraning = "DprNonOnfitUserInputMask_ParticipantsOutdoorTraning"
    [<Literal>]
    let DprNonOnfitUserInputMask_HoursSpendForTeamTraining = "DprNonOnfitUserInputMask_HoursSpendForTeamTraining"
    [<Literal>]
    let DprNonOnfitUserInputMask_SubmitButtonText = "DprNonOnfitUserInputMask_SubmitButtonText"
    [<Literal>]
    let DprNonOnfitUserInputMask_SubmitErrorTitle = "DprNonOnfitUserInputMask_SubmitErrorTitle"
    [<Literal>]
    let DprNonOnfitUserInputMask_SubmitErrorText = "DprNonOnfitUserInputMask_SubmitErrorText"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsAppliedInternal = "DprNonOnfitUserInputMask_RecoveryBootsAppliedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsAppliedExternal = "DprNonOnfitUserInputMask_RecoveryBootsAppliedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldInternal = "DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldExternal = "DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsSoldExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalInternal = "DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalExternal = "DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsTotalExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledInternal = "DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledExternal = "DprNonOnfitUserInputMask_RecoveryBootsSubscriptionsCanceledExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsTrainings = "DprNonOnfitUserInputMask_FusioneticsTrainings"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldInternal = "DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldExternal = "DprNonOnfitUserInputMask_FusioneticsSubscriptionsSoldExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalInternal = "DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalExternal = "DprNonOnfitUserInputMask_FusioneticsSubscriptionsTotalExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledInternal = "DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledExternal = "DprNonOnfitUserInputMask_FusioneticsSubscriptionsCanceledExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsTestSessionInternal = "DprNonOnfitUserInputMask_RecoveryBootsTestSessionInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_RecoveryBootsTestSessionExternal = "DprNonOnfitUserInputMask_RecoveryBootsTestSessionExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_ParticipantsFascialInfoEventInternal = "DprNonOnfitUserInputMask_ParticipantsFascialInfoEventInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_ParticipantsFascialInfoEventExternal = "DprNonOnfitUserInputMask_ParticipantsFascialInfoEventExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal1 = "DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal1"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromProbeTrainingOrConsultation = "DprNonOnfitUserInputMask_NewYearlyMembershipsContractedFromProbeTrainingOrConsultation"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromProbeTrainingOrConsultation = "DprNonOnfitUserInputMask_NewMonthToMonthMembershipsContractedFromProbeTrainingOrConsultation"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromProbeTrainingOrConsultation = "DprNonOnfitUserInputMask_NewPrepaidMembershipsContractedFromProbeTrainingOrConsultation"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromProbeTrainingOrConsultation = "DprNonOnfitUserInputMask_NewOtherMembershipsContractedFromProbeTrainingOrConsultation"
    [<Literal>]
    let DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsFromDateBook = "DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsFromDateBook"
    [<Literal>]
    let DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsDone = "DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal2 = "DprNonOnfitUserInputMask_NewMembershipsContractedFromProbeTrainingOrConsultationTotal2"
    [<Literal>]
    let DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromIncomingCalls = "DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromIncomingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromOutgoingCalls = "DprNonOnfitUserInputMask_ProbeTrainingsOrConsultationsBookedFromOutgoingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_SalesQuotaFromProbeTrainingOrConsultation = "DprNonOnfitUserInputMask_SalesQuotaFromProbeTrainingOrConsultation"
    [<Literal>]
    let DprNonOnfitUserInputMask_ShowUpQuotaProbeTrainingOrConsultation = "DprNonOnfitUserInputMask_ShowUpQuotaProbeTrainingOrConsultation"
    [<Literal>]
    let DprNonOnfitUserInputMask_InquiriesTotal = "DprNonOnfitUserInputMask_InquiriesTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_ConversionRateQuota = "DprNonOnfitUserInputMask_ConversionRateQuota"
    [<Literal>]
    let DprNonOnfitUserInputMask_PtgQuota = "DprNonOnfitUserInputMask_PtgQuota"
    [<Literal>]
    let DprNonOnfitUserInputMask_BeBacksFromDone = "DprNonOnfitUserInputMask_BeBacksFromDone"
    [<Literal>]
    let DprNonOnfitUserInputMask_BeBacksFromCompleted = "DprNonOnfitUserInputMask_BeBacksFromCompleted"
    [<Literal>]
    let DprNonOnfitUserInputMask_ErrorsInForm = "DprNonOnfitUserInputMask_ErrorsInForm"
    [<Literal>]
    let DprNonOnfitUserInputMask_GeneralErrorsModal_Title = "DprNonOnfitUserInputMask_GeneralErrorsModal_Title"
    [<Literal>]
    let DprNonOnfitUserInputMask_GeneralErrorsModal_Text = "DprNonOnfitUserInputMask_GeneralErrorsModal_Text"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pricing20 = "DprNonOnfitUserInputMask_Pricing20"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedClassic = "DprNonOnfitUserInputMask_NewMembershipsContractedClassic"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedBasic = "DprNonOnfitUserInputMask_NewMembershipsContractedBasic"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedComfort = "DprNonOnfitUserInputMask_NewMembershipsContractedComfort"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedPremium = "DprNonOnfitUserInputMask_NewMembershipsContractedPremium"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedClassicPercent = "DprNonOnfitUserInputMask_NewMembershipsContractedClassicPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedBasicPercent = "DprNonOnfitUserInputMask_NewMembershipsContractedBasicPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedComfortPercent = "DprNonOnfitUserInputMask_NewMembershipsContractedComfortPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_NewMembershipsContractedPremiumPercent = "DprNonOnfitUserInputMask_NewMembershipsContractedPremiumPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_UpsellingForPricing20Total = "DprNonOnfitUserInputMask_UpsellingForPricing20Total"
    [<Literal>]
    let DprNonOnfitUserInputMask_UpsellingForPricing20ClassicToPremium = "DprNonOnfitUserInputMask_UpsellingForPricing20ClassicToPremium"
    [<Literal>]
    let DprNonOnfitUserInputMask_UpsellingForPricing20BasicToComfort = "DprNonOnfitUserInputMask_UpsellingForPricing20BasicToComfort"
    [<Literal>]
    let DprNonOnfitUserInputMask_UpsellingForPricing20BasicToPremium = "DprNonOnfitUserInputMask_UpsellingForPricing20BasicToPremium"
    [<Literal>]
    let DprNonOnfitUserInputMask_UpsellingForPricing20ComfortToPremium = "DprNonOnfitUserInputMask_UpsellingForPricing20ComfortToPremium"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20Classic = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20Classic"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20Basic = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20Basic"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20Comfort = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20Comfort"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20Premium = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20Premium"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20ClassicPercent = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20ClassicPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20BasicPercent = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20BasicPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20ComfortPercent = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20ComfortPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_IncomingCancellationsPricing20PremiumPercent = "DprNonOnfitUserInputMask_IncomingCancellationsPricing20PremiumPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersClassic = "DprNonOnfitUserInputMask_MembersClassic"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersBasic = "DprNonOnfitUserInputMask_MembersBasic"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersComfort = "DprNonOnfitUserInputMask_MembersComfort"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersPremium = "DprNonOnfitUserInputMask_MembersPremium"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersClassicPercent = "DprNonOnfitUserInputMask_MembersClassicPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersBasicPercent = "DprNonOnfitUserInputMask_MembersBasicPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersComfortPercent = "DprNonOnfitUserInputMask_MembersComfortPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_MembersPremiumPercent = "DprNonOnfitUserInputMask_MembersPremiumPercent"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviPassesBookedTotal = "DprNonOnfitUserInputMask_PelviPassesBookedTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi10PassBookedInternal = "DprNonOnfitUserInputMask_Pelvi10PassBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi20PassBookedInternal = "DprNonOnfitUserInputMask_Pelvi20PassBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi30PassBookedInternal = "DprNonOnfitUserInputMask_Pelvi30PassBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi40PassBookedInternal = "DprNonOnfitUserInputMask_Pelvi40PassBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviOtherPassBookedInternal = "DprNonOnfitUserInputMask_PelviOtherPassBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi10PassBookedExternal = "DprNonOnfitUserInputMask_Pelvi10PassBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi20PassBookedExternal = "DprNonOnfitUserInputMask_Pelvi20PassBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi30PassBookedExternal = "DprNonOnfitUserInputMask_Pelvi30PassBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi40PassBookedExternal = "DprNonOnfitUserInputMask_Pelvi40PassBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviOtherPassBookedExternal = "DprNonOnfitUserInputMask_PelviOtherPassBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviFollowUpBookedInternal = "DprNonOnfitUserInputMask_PelviFollowUpBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi10FollowUpBookedInternal = "DprNonOnfitUserInputMask_Pelvi10FollowUpBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi20FollowUpBookedInternal = "DprNonOnfitUserInputMask_Pelvi20FollowUpBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi30FollowUpBookedInternal = "DprNonOnfitUserInputMask_Pelvi30FollowUpBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi40FollowUpBookedInternal = "DprNonOnfitUserInputMask_Pelvi40FollowUpBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviOtherFollowUpBookedInternal = "DprNonOnfitUserInputMask_PelviOtherFollowUpBookedInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviFollowUpBookedExternal = "DprNonOnfitUserInputMask_PelviFollowUpBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi10FollowUpBookedExternal = "DprNonOnfitUserInputMask_Pelvi10FollowUpBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi20FollowUpBookedExternal = "DprNonOnfitUserInputMask_Pelvi20FollowUpBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi30FollowUpBookedExternal = "DprNonOnfitUserInputMask_Pelvi30FollowUpBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_Pelvi40FollowUpBookedExternal = "DprNonOnfitUserInputMask_Pelvi40FollowUpBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviOtherFollowUpBookedExternal = "DprNonOnfitUserInputMask_PelviOtherFollowUpBookedExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviNewMembershipsContractedTotal = "DprNonOnfitUserInputMask_PelviNewMembershipsContractedTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviNewYearlyMemberships = "DprNonOnfitUserInputMask_PelviNewYearlyMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviNewMonthToMonthMemberships = "DprNonOnfitUserInputMask_PelviNewMonthToMonthMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviNewPrepaidMemberships = "DprNonOnfitUserInputMask_PelviNewPrepaidMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviNewOtherMemberships = "DprNonOnfitUserInputMask_PelviNewOtherMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviIncomingCancellationsTotal = "DprNonOnfitUserInputMask_PelviIncomingCancellationsTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviIncomingCancellationsYearlyMemberships = "DprNonOnfitUserInputMask_PelviIncomingCancellationsYearlyMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviIncomingCancellationsMonthToMonthMemberships = "DprNonOnfitUserInputMask_PelviIncomingCancellationsMonthToMonthMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviIncomingCancellationsPrepaidMemberships = "DprNonOnfitUserInputMask_PelviIncomingCancellationsPrepaidMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviIncomingCancellationsOtherMemberships = "DprNonOnfitUserInputMask_PelviIncomingCancellationsOtherMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviAbosTotal = "DprNonOnfitUserInputMask_PelviAbosTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviAbosYearlyMemberships = "DprNonOnfitUserInputMask_PelviAbosYearlyMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviAbosMonthToMonthMemberships = "DprNonOnfitUserInputMask_PelviAbosMonthToMonthMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviAbosPrepaidMemberships = "DprNonOnfitUserInputMask_PelviAbosPrepaidMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviAbosOtherMemberships = "DprNonOnfitUserInputMask_PelviAbosOtherMemberships"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToComfort = "DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToComfort"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToPremium = "DprNonOnfitUserInputMask_PelviUpsellFromPlusAboToPremium"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviUpsellFromExternalToInternal = "DprNonOnfitUserInputMask_PelviUpsellFromExternalToInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookInternal = "DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviProbeTrainingsDoneInternal = "DprNonOnfitUserInputMask_PelviProbeTrainingsDoneInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviSubscriptionsSoldInternal = "DprNonOnfitUserInputMask_PelviSubscriptionsSoldInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingInternal = "DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingInternal = "DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingInternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookExternal = "DprNonOnfitUserInputMask_PelviProbeTrainingsInDateBookExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviProbeTrainingsDoneExternal = "DprNonOnfitUserInputMask_PelviProbeTrainingsDoneExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviSubscriptionsSoldExternal = "DprNonOnfitUserInputMask_PelviSubscriptionsSoldExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingExternal = "DprNonOnfitUserInputMask_PelviShowUpQuotaProbeTrainingExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingExternal = "DprNonOnfitUserInputMask_PelviBookingQuotaFromProbeTrainingExternal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviOutgoingCallsAttempted = "DprNonOnfitUserInputMask_PelviOutgoingCallsAttempted"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviOutgoingCallsSuccessful = "DprNonOnfitUserInputMask_PelviOutgoingCallsSuccessful"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviProbeTrainingsBookedFromOutgoingCalls = "DprNonOnfitUserInputMask_PelviProbeTrainingsBookedFromOutgoingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviCatchingQuotaForOutgoingCalls = "DprNonOnfitUserInputMask_PelviCatchingQuotaForOutgoingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookingQuotaFromOutgoingCalls = "DprNonOnfitUserInputMask_PelviBookingQuotaFromOutgoingCalls"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalTotal = "DprNonOnfitUserInputMask_PelviBookedExternalTotal"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromFlyersOrClassicMail = "DprNonOnfitUserInputMask_PelviBookedExternalFromFlyersOrClassicMail"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromRecommendations = "DprNonOnfitUserInputMask_PelviBookedExternalFromRecommendations"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromAdsOrPressAnnouncement = "DprNonOnfitUserInputMask_PelviBookedExternalFromAdsOrPressAnnouncement"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromExterior = "DprNonOnfitUserInputMask_PelviBookedExternalFromExterior"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromStreetPromotion = "DprNonOnfitUserInputMask_PelviBookedExternalFromStreetPromotion"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromLuckyBoxGame = "DprNonOnfitUserInputMask_PelviBookedExternalFromLuckyBoxGame"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromDirectMailing = "DprNonOnfitUserInputMask_PelviBookedExternalFromDirectMailing"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromExternalOrInternalEvents = "DprNonOnfitUserInputMask_PelviBookedExternalFromExternalOrInternalEvents"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromCooperations = "DprNonOnfitUserInputMask_PelviBookedExternalFromCooperations"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromGuestPasses = "DprNonOnfitUserInputMask_PelviBookedExternalFromGuestPasses"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromInternet = "DprNonOnfitUserInputMask_PelviBookedExternalFromInternet"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromSMSTool = "DprNonOnfitUserInputMask_PelviBookedExternalFromSMSTool"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromOrRadioTV = "DprNonOnfitUserInputMask_PelviBookedExternalFromOrRadioTV"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromOtherOutsideAds = "DprNonOnfitUserInputMask_PelviBookedExternalFromOtherOutsideAds"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromFormerMembers = "DprNonOnfitUserInputMask_PelviBookedExternalFromFormerMembers"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromStudies = "DprNonOnfitUserInputMask_PelviBookedExternalFromStudies"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromOutdoorTraining = "DprNonOnfitUserInputMask_PelviBookedExternalFromOutdoorTraining"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromHpm = "DprNonOnfitUserInputMask_PelviBookedExternalFromHpm"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromFacebook = "DprNonOnfitUserInputMask_PelviBookedExternalFromFacebook"
    [<Literal>]
    let DprNonOnfitUserInputMask_PelviBookedExternalFromRestSources = "DprNonOnfitUserInputMask_PelviBookedExternalFromRestSources"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsTotalPelvi = "DprNonOnfitUserInputMask_ContactsTotalPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromFlyersOrClassicMailPelvi = "DprNonOnfitUserInputMask_ContactsFromFlyersOrClassicMailPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromRecommendationsPelvi = "DprNonOnfitUserInputMask_ContactsFromRecommendationsPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromAdsOrPressAnnouncementPelvi = "DprNonOnfitUserInputMask_ContactsFromAdsOrPressAnnouncementPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromExteriorPelvi = "DprNonOnfitUserInputMask_ContactsFromExteriorPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromStreetPromotionPelvi = "DprNonOnfitUserInputMask_ContactsFromStreetPromotionPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromLuckyBoxGamePelvi = "DprNonOnfitUserInputMask_ContactsFromLuckyBoxGamePelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromDirectMailingPelvi = "DprNonOnfitUserInputMask_ContactsFromDirectMailingPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEventsPelvi = "DprNonOnfitUserInputMask_ContactsFromExternalOrInternalEventsPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromCooperationsPelvi = "DprNonOnfitUserInputMask_ContactsFromCooperationsPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromGuestPassesPelvi = "DprNonOnfitUserInputMask_ContactsFromGuestPassesPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromInternetPelvi = "DprNonOnfitUserInputMask_ContactsFromInternetPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromSMSToolPelvi = "DprNonOnfitUserInputMask_ContactsFromSMSToolPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromOrRadioTVPelvi = "DprNonOnfitUserInputMask_ContactsFromOrRadioTVPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromOtherOutsideAdsPelvi = "DprNonOnfitUserInputMask_ContactsFromOtherOutsideAdsPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromFormerMembersPelvi = "DprNonOnfitUserInputMask_ContactsFromFormerMembersPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromStudiesPelvi = "DprNonOnfitUserInputMask_ContactsFromStudiesPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromOutdoorTrainingPelvi = "DprNonOnfitUserInputMask_ContactsFromOutdoorTrainingPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromHpmPelvi = "DprNonOnfitUserInputMask_ContactsFromHpmPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromFacebookPelvi = "DprNonOnfitUserInputMask_ContactsFromFacebookPelvi"
    [<Literal>]
    let DprNonOnfitUserInputMask_ContactsFromRestSourcesPelvi = "DprNonOnfitUserInputMask_ContactsFromRestSourcesPelvi"
    [<Literal>]
    let DprCheckRule_OnlyZeros = "DprCheckRule_OnlyZeros"
    [<Literal>]
    let DprCheckRule_NoTotalMembers = "DprCheckRule_NoTotalMembers"
    [<Literal>]
    let DprCheckRule_TooManyTotalMembers = "DprCheckRule_TooManyTotalMembers"
    [<Literal>]
    let DprCheckRule_TooManyNewMembers = "DprCheckRule_TooManyNewMembers"
    [<Literal>]
    let DprCheckRule_SpreadFlyersInWrongField = "DprCheckRule_SpreadFlyersInWrongField"
    [<Literal>]
    let BwaInputMask_NettoSalesFromMembers = "BwaInputMask_NettoSalesFromMembers"
    [<Literal>]
    let BwaInputMask_NettoSalesFromMembers_Extend1 = "BwaInputMask_NettoSalesFromMembers_Extend1"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromPelviPower = "BwaInputMask_NettoIncomeFromPelviPower"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromPelviPower_Extend1 = "BwaInputMask_NettoIncomeFromPelviPower_Extend1"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromBoots = "BwaInputMask_NettoIncomeFromBoots"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromBoots_Extend1 = "BwaInputMask_NettoIncomeFromBoots_Extend1"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromFusionetics = "BwaInputMask_NettoIncomeFromFusionetics"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromFusionetics_Extend1 = "BwaInputMask_NettoIncomeFromFusionetics_Extend1"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromKilosWeg = "BwaInputMask_NettoIncomeFromKilosWeg"
    [<Literal>]
    let BwaInputMask_NettoIncomeFromKilosWeg_Extend1 = "BwaInputMask_NettoIncomeFromKilosWeg_Extend1"
    [<Literal>]
    let BwaInputMask_NettoOtherSales = "BwaInputMask_NettoOtherSales"
    [<Literal>]
    let BwaInputMask_NettoOtherSales_Extend1 = "BwaInputMask_NettoOtherSales_Extend1"
    [<Literal>]
    let BwaInputMask_NettoSalesTotal = "BwaInputMask_NettoSalesTotal"
    [<Literal>]
    let BwaInputMask_NettoSalesTotal_Extend1 = "BwaInputMask_NettoSalesTotal_Extend1"
    [<Literal>]
    let BwaInputMask_SalaryAndSocial = "BwaInputMask_SalaryAndSocial"
    [<Literal>]
    let BwaInputMask_SalaryAndSocial_Extend1 = "BwaInputMask_SalaryAndSocial_Extend1"
    [<Literal>]
    let BwaInputMask_NettoRentAndAdditionalCosts = "BwaInputMask_NettoRentAndAdditionalCosts"
    [<Literal>]
    let BwaInputMask_NettoRentAndAdditionalCosts_Extend1 = "BwaInputMask_NettoRentAndAdditionalCosts_Extend1"
    [<Literal>]
    let BwaInputMask_NettoLocalMarketingCosts = "BwaInputMask_NettoLocalMarketingCosts"
    [<Literal>]
    let BwaInputMask_NettoLocalMarketingCosts_Extend1 = "BwaInputMask_NettoLocalMarketingCosts_Extend1"
    [<Literal>]
    let BwaInputMask_NettoOtherCosts = "BwaInputMask_NettoOtherCosts"
    [<Literal>]
    let BwaInputMask_NettoOtherCosts_Extend1 = "BwaInputMask_NettoOtherCosts_Extend1"
    [<Literal>]
    let BwaInputMask_NettoCostsTotal = "BwaInputMask_NettoCostsTotal"
    [<Literal>]
    let BwaInputMask_NettoCostsTotal_Extend1 = "BwaInputMask_NettoCostsTotal_Extend1"
    [<Literal>]
    let BwaInputMask_ResultEBITDA = "BwaInputMask_ResultEBITDA"
    [<Literal>]
    let BwaInputMask_ResultEBITDA_Extend1 = "BwaInputMask_ResultEBITDA_Extend1"
    [<Literal>]
    let BwaInputMask_SubmitButtonText = "BwaInputMask_SubmitButtonText"
    [<Literal>]
    let BwaInputMask_StatisticHeadline = "BwaInputMask_StatisticHeadline"
    [<Literal>]
    let BwaInputMask_StatisticHeadline_Extend1 = "BwaInputMask_StatisticHeadline_Extend1"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromPelviPower = "BwaInputMask_StatisticIncomeFromPelviPower"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromPelviPower_Extend1 = "BwaInputMask_StatisticIncomeFromPelviPower_Extend1"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromBoots = "BwaInputMask_StatisticIncomeFromBoots"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromBoots_Extend1 = "BwaInputMask_StatisticIncomeFromBoots_Extend1"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromFusionetics = "BwaInputMask_StatisticIncomeFromFusionetics"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromFusionetics_Extend1 = "BwaInputMask_StatisticIncomeFromFusionetics_Extend1"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromKilosWeg = "BwaInputMask_StatisticIncomeFromKilosWeg"
    [<Literal>]
    let BwaInputMask_StatisticIncomeFromKilosWeg_Extend1 = "BwaInputMask_StatisticIncomeFromKilosWeg_Extend1"
    [<Literal>]
    let BwaInputMask_SubmitErrorTitle = "BwaInputMask_SubmitErrorTitle"
    [<Literal>]
    let BwaInputMask_SubmitErrorText = "BwaInputMask_SubmitErrorText"
    [<Literal>]
    let BwaInputMask_Validation_TooBig = "BwaInputMask_Validation_TooBig"
    [<Literal>]
    let BwaInputMask_Validation_BelowZero = "BwaInputMask_Validation_BelowZero"
    [<Literal>]
    let FormValidation_NotAnInt = "FormValidation_NotAnInt"
    [<Literal>]
    let FormValidation_NotADecimal = "FormValidation_NotADecimal"
    [<Literal>]
    let FormValidation_MandatoryButEmpty = "FormValidation_MandatoryButEmpty"
    [<Literal>]
    let FormValidation_NotADate = "FormValidation_NotADate"
    [<Literal>]
    let FormValidation_DateToBig = "FormValidation_DateToBig"
    [<Literal>]
    let FormValidation_DateToSmall = "FormValidation_DateToSmall"
    [<Literal>]
    let FormValidation_NotAClubWithDpr = "FormValidation_NotAClubWithDpr"
    [<Literal>]
    let ReportHeadline_BlitzDpr = "ReportHeadline_BlitzDpr"
    [<Literal>]
    let ReportHeadline_existingMembers = "ReportHeadline_existingMembers"
    [<Literal>]
    let ReportHeadline_MembersRecruitingAndSalesprocess = "ReportHeadline_MembersRecruitingAndSalesprocess"
    [<Literal>]
    let ReportHeadline_Marketing = "ReportHeadline_Marketing"
    [<Literal>]
    let ReportHeadline_Loyalty = "ReportHeadline_Loyalty"
    [<Literal>]
    let ReportHeadline_Clubmanagement = "ReportHeadline_Clubmanagement"
    [<Literal>]
    let ReportHeadline_MrsSportyPlus = "ReportHeadline_MrsSportyPlus"
    [<Literal>]
    let ReportHeadline_MrsSportyPlus_RecoveryBoots = "ReportHeadline_MrsSportyPlus_RecoveryBoots"
    [<Literal>]
    let ReportHeadline_MrsSportyPlus_Fusionetics = "ReportHeadline_MrsSportyPlus_Fusionetics"
    [<Literal>]
    let ReportHeadline_MrsSportyPlus_PelviPower = "ReportHeadline_MrsSportyPlus_PelviPower"
    [<Literal>]
    let ReportHeadline_PelviPower_Plus_Abo = "ReportHeadline_PelviPower_Plus_Abo"
    [<Literal>]
    let ReportHeadline_MrsSportyPlus_PelviPower_Sales = "ReportHeadline_MrsSportyPlus_PelviPower_Sales"
    [<Literal>]
    let ReportHeadline_ExcelExportQuotaBlock = "ReportHeadline_ExcelExportQuotaBlock"
    [<Literal>]
    let ReportHeadline_Pricing20 = "ReportHeadline_Pricing20"
    [<Literal>]
    let ControlPanel_Title = "ControlPanel_Title"
    [<Literal>]
    let ControlPanel_SubTitle = "ControlPanel_SubTitle"
    [<Literal>]
    let ControlPanel_Bwa_Title = "ControlPanel_Bwa_Title"
    [<Literal>]
    let ControlPanel_Dpr_Title = "ControlPanel_Dpr_Title"
    [<Literal>]
    let ControlPanel_Dpr_Report_Link_Text = "ControlPanel_Dpr_Report_Link_Text"
    [<Literal>]
    let ControlPanel_Dpr_Legal_Title = "ControlPanel_Dpr_Legal_Title"
    [<Literal>]
    let ControlPanel_Dpr_Legal_Text = "ControlPanel_Dpr_Legal_Text"
    [<Literal>]
    let ControlPanel_Dpr_Legal_Link = "ControlPanel_Dpr_Legal_Link"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Title = "ControlPanel_Dpr_ClubSettings_Title"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Text = "ControlPanel_Dpr_ClubSettings_Text"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Table_Club = "ControlPanel_Dpr_ClubSettings_Table_Club"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Table_OptIn = "ControlPanel_Dpr_ClubSettings_Table_OptIn"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Table_OptIn_NotAvailable = "ControlPanel_Dpr_ClubSettings_Table_OptIn_NotAvailable"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Table_OptIn_Blacklisted = "ControlPanel_Dpr_ClubSettings_Table_OptIn_Blacklisted"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Table_OptIn_OptOutMessage = "ControlPanel_Dpr_ClubSettings_Table_OptIn_OptOutMessage"
    [<Literal>]
    let ControlPanel_Dpr_ClubSettings_Table_OptIn_OptInMessage = "ControlPanel_Dpr_ClubSettings_Table_OptIn_OptInMessage"
    [<Literal>]
    let ControlPanel_Dpr_EditDpr_Title = "ControlPanel_Dpr_EditDpr_Title"
    [<Literal>]
    let ControlPanel_Dpr_EditDpr_EntryNotFoundError = "ControlPanel_Dpr_EditDpr_EntryNotFoundError"
    [<Literal>]
    let ControlPanel_Dpr_EditDpr_SubmitButtonText = "ControlPanel_Dpr_EditDpr_SubmitButtonText"
    [<Literal>]
    let ControlPanel_Dpr_EditDpr_ClubLabelText = "ControlPanel_Dpr_EditDpr_ClubLabelText"
    [<Literal>]
    let ControlPanel_Notifications_BwaInput_Pending_Heading = "ControlPanel_Notifications_BwaInput_Pending_Heading"
    [<Literal>]
    let ControlPanel_Notifications_BwaInput_Pending_Text = "ControlPanel_Notifications_BwaInput_Pending_Text"
    [<Literal>]
    let ControlPanel_Notifications_BwaInput_Pending_Linktext = "ControlPanel_Notifications_BwaInput_Pending_Linktext"
    [<Literal>]
    let ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Heading = "ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Heading"
    [<Literal>]
    let ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Text = "ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Text"
    [<Literal>]
    let ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Linktext = "ControlPanel_Notifications_BwaInput_BwaDoneAndReversable_Linktext"
    [<Literal>]
    let ControlPanel_Notifications_DprInput_Pending_Heading = "ControlPanel_Notifications_DprInput_Pending_Heading"
    [<Literal>]
    let ControlPanel_Notifications_DprInput_Pending_Text = "ControlPanel_Notifications_DprInput_Pending_Text"
    [<Literal>]
    let ControlPanel_Notifications_DprInput_Pending_Linktext = "ControlPanel_Notifications_DprInput_Pending_Linktext"
    [<Literal>]
    let ControlPanel_Notifications_DprInput_Skip_Linktext = "ControlPanel_Notifications_DprInput_Skip_Linktext"
    [<Literal>]
    let ControlPanel_Notifications_DprInput_Skip_Confirmation_Text = "ControlPanel_Notifications_DprInput_Skip_Confirmation_Text"
    [<Literal>]
    let ControlPanel_Invoices_Title = "ControlPanel_Invoices_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_Invoice_Number_Title = "ControlPanel_Invoices_Column_Invoice_Number_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_Invoice_Date_Title = "ControlPanel_Invoices_Column_Invoice_Date_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_DueDate_Title = "ControlPanel_Invoices_Column_DueDate_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_Club_Number_Title = "ControlPanel_Invoices_Column_Club_Number_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_Product_Title = "ControlPanel_Invoices_Column_Product_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_Invoice_Amount_Title = "ControlPanel_Invoices_Column_Invoice_Amount_Title"
    [<Literal>]
    let ControlPanel_Invoices_Column_Actions_Download = "ControlPanel_Invoices_Column_Actions_Download"
    [<Literal>]
    let ControlPanel_Invoices_Column_Actions_Show = "ControlPanel_Invoices_Column_Actions_Show"
    [<Literal>]
    let ControlPanel_Invoices_Column_Notes_Title = "ControlPanel_Invoices_Column_Notes_Title"
    [<Literal>]
    let ControlPanel_Invoices_No_Invoices_Message = "ControlPanel_Invoices_No_Invoices_Message"
    [<Literal>]
    let PasswordRecovery_PageTitle = "PasswordRecovery_PageTitle"
    [<Literal>]
    let PasswordRecovery_ForgotPasswordLink = "PasswordRecovery_ForgotPasswordLink"
    [<Literal>]
    let PasswordRecovery_Info = "PasswordRecovery_Info"
    [<Literal>]
    let PasswordRecovery_EmailLabel = "PasswordRecovery_EmailLabel"
    [<Literal>]
    let PasswordRecovery_EmailPlaceholder = "PasswordRecovery_EmailPlaceholder"
    [<Literal>]
    let PasswordRecovery_EmailMissing = "PasswordRecovery_EmailMissing"
    [<Literal>]
    let PasswordRecovery_EmailNotValid = "PasswordRecovery_EmailNotValid"
    [<Literal>]
    let PasswordRecovery_ResetPasswordButton = "PasswordRecovery_ResetPasswordButton"
    [<Literal>]
    let PasswordRecovery_BackToLogin = "PasswordRecovery_BackToLogin"
    [<Literal>]
    let PasswordRecovery_ForgotPasswordConfirmationPageTitle = "PasswordRecovery_ForgotPasswordConfirmationPageTitle"
    [<Literal>]
    let PasswordRecovery_ForgotPasswordConfirmation = "PasswordRecovery_ForgotPasswordConfirmation"
    [<Literal>]
    let PasswordRecovery_EmailSubject = "PasswordRecovery_EmailSubject"
    [<Literal>]
    let PasswordRecovery_EmailText = "PasswordRecovery_EmailText"
    [<Literal>]
    let ResetPassword_PageTitle = "ResetPassword_PageTitle"
    [<Literal>]
    let ResetPassword_Info = "ResetPassword_Info"
    [<Literal>]
    let ResetPassword_NewPasswordRequired = "ResetPassword_NewPasswordRequired"
    [<Literal>]
    let ResetPassword_NewPasswordLabel = "ResetPassword_NewPasswordLabel"
    [<Literal>]
    let ResetPassword_NewPasswordPlaceholder = "ResetPassword_NewPasswordPlaceholder"
    [<Literal>]
    let ResetPassword_ConfirmationLabel = "ResetPassword_ConfirmationLabel"
    [<Literal>]
    let ResetPassword_ConfirmationDoesNotMatch = "ResetPassword_ConfirmationDoesNotMatch"
    [<Literal>]
    let ResetPassword_SetPassword = "ResetPassword_SetPassword"
    [<Literal>]
    let ResetPassword_BackToHome = "ResetPassword_BackToHome"
    [<Literal>]
    let ResetPassword_ConfirmationPageTitle = "ResetPassword_ConfirmationPageTitle"
    [<Literal>]
    let ResetPassword_Confirmation = "ResetPassword_Confirmation"
    [<Literal>]
    let ResetPassword_GeneralError = "ResetPassword_GeneralError"
    [<Literal>]
    let RequestNewPassword_Title = "RequestNewPassword_Title"
    [<Literal>]
    let RequestNewPassword_Info = "RequestNewPassword_Info"
    [<Literal>]
    let RequestNewPassword_CurrentPasswordLabel = "RequestNewPassword_CurrentPasswordLabel"
    [<Literal>]
    let RequestNewPassword_CurrentPasswordPlaceholder = "RequestNewPassword_CurrentPasswordPlaceholder"
    [<Literal>]
    let RequestNewPassword_CurrentPasswordMissing = "RequestNewPassword_CurrentPasswordMissing"
    [<Literal>]
    let RequestNewPassword_PasswordDoesNotMatch = "RequestNewPassword_PasswordDoesNotMatch"
    [<Literal>]
    let RequestNewPassword_BackToHome = "RequestNewPassword_BackToHome"
    [<Literal>]
    let ForceNewPassword_PageTitle = "ForceNewPassword_PageTitle"
    [<Literal>]
    let ForceNewPassword_Info = "ForceNewPassword_Info"
    [<Literal>]
    let ForceNewPassword_Confirmation = "ForceNewPassword_Confirmation"
    [<Literal>]
    let ForceNewPassword_Cancel = "ForceNewPassword_Cancel"
    [<Literal>]
    let Identity_PasswordRequiresDigit = "Identity_PasswordRequiresDigit"
    [<Literal>]
    let Identity_PasswordRequiresLower = "Identity_PasswordRequiresLower"
    [<Literal>]
    let Identity_PasswordRequiresNonAlphanumeric = "Identity_PasswordRequiresNonAlphanumeric"
    [<Literal>]
    let Identity_PasswordRequiresUniqueChars = "Identity_PasswordRequiresUniqueChars"
    [<Literal>]
    let Identity_PasswordRequiresUpper = "Identity_PasswordRequiresUpper"
    [<Literal>]
    let Identity_PasswordTooShort = "Identity_PasswordTooShort"
    [<Literal>]
    let Identity_PasswordDoesntDiffer = "Identity_PasswordDoesntDiffer"
    [<Literal>]
    let UserDropdown_ChangePassword = "UserDropdown_ChangePassword"
    [<Literal>]
    let UserDropdown_Logout = "UserDropdown_Logout"
    [<Literal>]
    let Report_Intervall = "Report_Intervall"
    [<Literal>]
    let Report_Intervall_Month = "Report_Intervall_Month"
    [<Literal>]
    let Report_Intervall_Quarter = "Report_Intervall_Quarter"
    [<Literal>]
    let Report_Intervall_HalfYear = "Report_Intervall_HalfYear"
    [<Literal>]
    let Report_Intervall_Year = "Report_Intervall_Year"
    [<Literal>]
    let Report_From = "Report_From"
    [<Literal>]
    let Report_ExcelExport_Button = "Report_ExcelExport_Button"
    [<Literal>]
    let Report_ExcelExport_LikeSelected = "Report_ExcelExport_LikeSelected"
    [<Literal>]
    let Report_ExcelExport_CurrentMonth = "Report_ExcelExport_CurrentMonth"
    [<Literal>]
    let Report_ExcelExport_PreviousMonth = "Report_ExcelExport_PreviousMonth"
    [<Literal>]
    let Report_ExcelExport_CurrentYear = "Report_ExcelExport_CurrentYear"
    [<Literal>]
    let Report_ExcelExport_PreviousYear = "Report_ExcelExport_PreviousYear"
    [<Literal>]
    let Report_ExcelExport_PreviousTwoYears = "Report_ExcelExport_PreviousTwoYears"
    [<Literal>]
    let Report_ExcelExport_TotalPeriod = "Report_ExcelExport_TotalPeriod"
    [<Literal>]
    let Error_AccessDenied = "Error_AccessDenied"
    [<Literal>]
    let Error_AccessDenied_Text = "Error_AccessDenied_Text"
    [<Literal>]
    let Error_AccessDenied_Logout = "Error_AccessDenied_Logout"
    [<Literal>]
    let Error_Back = "Error_Back"
    [<Literal>]
    let Error_GeneralError_Title = "Error_GeneralError_Title"
    [<Literal>]
    let Error_GeneralError_Text = "Error_GeneralError_Text"
    [<Literal>]
    let Error_500_Title = "Error_500_Title"
    [<Literal>]
    let Error_500_Text = "Error_500_Text"
    [<Literal>]
    let Error_404_Title = "Error_404_Title"
    [<Literal>]
    let Error_404_Text = "Error_404_Text"
    [<Literal>]
    let Error_503_Title = "Error_503_Title"
    [<Literal>]
    let Error_503_Text = "Error_503_Text"
    [<Literal>]
    let Dpr_Title = "Dpr_Title"
    [<Literal>]
    let Dpr_IncludeInReport = "Dpr_IncludeInReport"
    [<Literal>]
    let Dpr_AggregatedSumValue = "Dpr_AggregatedSumValue"
    [<Literal>]
    let Dpr_AggregatedAverageValue = "Dpr_AggregatedAverageValue"
    [<Literal>]
    let Dpr_Origin_Import = "Dpr_Origin_Import"
    [<Literal>]
    let Dpr_Origin_Sync = "Dpr_Origin_Sync"
    [<Literal>]
    let Dpr_Origin_Manual = "Dpr_Origin_Manual"
    [<Literal>]
    let DPRChart_DisplayDatalabels = "DPRChart_DisplayDatalabels"
    [<Literal>]
    let DprChart_Title = "DprChart_Title"
    [<Literal>]
    let DprChart_Type_Title = "DprChart_Type_Title"
    [<Literal>]
    let DprChart_Type_Line = "DprChart_Type_Line"
    [<Literal>]
    let DprChart_Type_Bar = "DprChart_Type_Bar"
    [<Literal>]
    let Imprint_Title = "Imprint_Title"
    [<Literal>]
    let Imprint_Back = "Imprint_Back"
    [<Literal>]
    let BlitzDprMail_DoNotReply = "BlitzDprMail_DoNotReply"
    [<Literal>]
    let BlitzDprMail_Club = "BlitzDprMail_Club"
    [<Literal>]
    let BlitzDprMail_CreationTimestamp = "BlitzDprMail_CreationTimestamp"
    [<Literal>]
    let BlitzDprMail_CoveredPeriod = "BlitzDprMail_CoveredPeriod"
    [<Literal>]
    let BlitzDprMail_Subject_FirstWord = "BlitzDprMail_Subject_FirstWord"
    [<Literal>]
    let Modal_Close_Button_Text = "Modal_Close_Button_Text"
